"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[890],{

/***/ 3739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_Typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7734);


var Button = function(param) {
    var children = param.children, _noBorder = param.noBorder, noBorder = _noBorder === void 0 ? false : _noBorder;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "relative inline-block mb-2 after:transition-all after:absolute after:left-4 after:z-0 after:top-2 after:w-full after:h-full after:border-b-8 after:border-r-8 after:border-yellow after:opacity-0 hover:after:opacity-100",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "relative z-10 mb-2 transition-all border-yellow text-yellow bg-almostBlack ".concat(!noBorder && "border-2"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_1__/* .H4Display */ .rd, {
                bold: true,
                children: children
            })
        })
    });
};


/***/ }),

/***/ 7504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q9": function() { return /* binding */ GridRowGroupOne; },
/* harmony export */   "T5": function() { return /* binding */ GridContainer; },
/* harmony export */   "X$": function() { return /* binding */ gridGutter; },
/* harmony export */   "wS": function() { return /* binding */ GridRowGroupTwo; }
/* harmony export */ });
/* unused harmony exports gridColumns, gridMargin, GridRow, GridRowGroupThree, GridRowGroupFour, GridRowGroupFive, GridRowGroupSix */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7479);
/* provided dependency */ var process = __webpack_require__(4155);



var appDebugMode = process.env.DEBUG_DESIGN_GRID_ROWS === "true";
var gridColumns = {
    mobile: "grid-cols-5",
    desktop: "md:grid-cols-13"
};
var gridGutter = {
    mobile: "gap-x-[.75rem]",
    desktop: "md:gap-x-[.75rem]"
};
var gridMargin = {
    mobile: "mx-[1rem]",
    desktop: "md:mx-[1.5rem]"
};
var baseGridClasses = "max-w-[2000px] grid ".concat(gridColumns.mobile, " ").concat(gridColumns.desktop, " ").concat(gridGutter.mobile, " ").concat(gridGutter.desktop);
var GridContainer = function(param) {
    var children = param.children, _noMargin = param.noMargin, noMargin = _noMargin === void 0 ? false : _noMargin, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? "" : _customStyles, _wrapperElement = param.wrapperElement, wrapperElement = _wrapperElement === void 0 ? "" : _wrapperElement;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_helpers__WEBPACK_IMPORTED_MODULE_2__/* .HTMLWrapper */ .oK, {
        classes: "".concat(customStyles, " ").concat(baseGridClasses, " ").concat(!noMargin && gridMargin.mobile, " ").concat(!noMargin && gridMargin.desktop),
        wrapperElement: wrapperElement,
        children: children
    });
};
var GridRow = function(param) {
    var children = param.children, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? "" : _customStyles, _wrapperElement = param.wrapperElement, wrapperElement = _wrapperElement === void 0 ? "div" : _wrapperElement, _gridRules = param.gridRules, gridRules = _gridRules === void 0 ? "" : _gridRules, _debugMode = param.debugMode, debugMode = _debugMode === void 0 ? false : _debugMode;
    var debugGridRowStyles = (appDebugMode || debugMode) && "bg-debugGrid";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_helpers__WEBPACK_IMPORTED_MODULE_2__/* .HTMLWrapper */ .oK, {
        classes: "".concat(gridRules, " ").concat(customStyles, " ").concat(debugGridRowStyles),
        wrapperElement: wrapperElement,
        children: children
    });
};
var GridRowGroupOne = function(param) {
    var children = param.children, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? "" : _customStyles, _wrapperElement = param.wrapperElement, wrapperElement = _wrapperElement === void 0 ? "div" : _wrapperElement, _debugMode = param.debugMode, debugMode = _debugMode === void 0 ? false : _debugMode;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GridRow, {
        gridRules: "!col-start-1 md:col-start-1 lg:col-start-1 col-span-full",
        customStyles: customStyles,
        wrapperElement: wrapperElement,
        debugMode: debugMode,
        children: children
    });
};
var GridRowGroupTwo = function(param) {
    var children = param.children, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? "" : _customStyles, _wrapperElement = param.wrapperElement, wrapperElement = _wrapperElement === void 0 ? "div" : _wrapperElement, _debugMode = param.debugMode, debugMode = _debugMode === void 0 ? false : _debugMode;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GridRow, {
        gridRules: "!col-start-1 col-span-full md:!col-start-2",
        customStyles: customStyles,
        wrapperElement: wrapperElement,
        debugMode: debugMode,
        children: children
    });
};
var GridRowGroupThree = function(param) {
    var children = param.children, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? "" : _customStyles, _wrapperElement = param.wrapperElement, wrapperElement = _wrapperElement === void 0 ? "div" : _wrapperElement, _debugMode = param.debugMode, debugMode = _debugMode === void 0 ? false : _debugMode;
    return /*#__PURE__*/ _jsx(GridRow, {
        gridRules: "!col-start-1 col-span-full md:!col-start-4 lg:!col-start-4",
        customStyles: customStyles,
        wrapperElement: wrapperElement,
        debugMode: debugMode,
        children: children
    });
};
var GridRowGroupFour = function(param) {
    var children = param.children, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? "" : _customStyles, _wrapperElement = param.wrapperElement, wrapperElement = _wrapperElement === void 0 ? "div" : _wrapperElement, _debugMode = param.debugMode, debugMode = _debugMode === void 0 ? false : _debugMode;
    return /*#__PURE__*/ _jsx(GridRow, {
        gridRules: "col-span-full !col-start-1 md:!col-start-5 lg:!col-start-5",
        customStyles: customStyles,
        wrapperElement: wrapperElement,
        debugMode: debugMode,
        children: children
    });
};
var GridRowGroupFive = function(param) {
    var children = param.children, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? "" : _customStyles, _wrapperElement = param.wrapperElement, wrapperElement = _wrapperElement === void 0 ? "div" : _wrapperElement, _debugMode = param.debugMode, debugMode = _debugMode === void 0 ? false : _debugMode;
    return /*#__PURE__*/ _jsx(GridRow, {
        gridRules: "col-span-full !col-start-2 md:!col-start-6 lg:!col-start-6",
        customStyles: customStyles,
        wrapperElement: wrapperElement,
        debugMode: debugMode,
        children: children
    });
};
var GridRowGroupSix = function(param) {
    var children = param.children, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? "" : _customStyles, _wrapperElement = param.wrapperElement, wrapperElement = _wrapperElement === void 0 ? "div" : _wrapperElement, _debugMode = param.debugMode, debugMode = _debugMode === void 0 ? false : _debugMode;
    return /*#__PURE__*/ _jsx(GridRow, {
        gridRules: "col-span-full !col-start-2 md:!col-start-6 lg:!col-start-9",
        customStyles: customStyles,
        wrapperElement: wrapperElement,
        debugMode: debugMode,
        children: children
    });
};


/***/ }),

/***/ 436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A0": function() { return /* binding */ IconMobileMenuOpen; },
/* harmony export */   "BX": function() { return /* binding */ IconCursor; },
/* harmony export */   "bM": function() { return /* binding */ IconClose; },
/* harmony export */   "kL": function() { return /* binding */ IconX; }
/* harmony export */ });
/* unused harmony exports Icon, IconArrow, IconDesktopComputer, IconEnvelope, IconMobileDevice, IconMonitor, IconPhone, IcoMonitor, IconPlay, IconPlus, IconWatch */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7479);



var Icon = function(param) {
    var customStyles = param.customStyles, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: customStyles,
        children: children
    });
};
var IconCursor = function(param) {
    var _animated = param.animated, animated = _animated === void 0 ? false : _animated, alt = param.alt, _color = param.color, color = _color === void 0 ? "white" : _color, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? "" : _customStyles;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Icon, {
        customStyles: customStyles,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: alt ? alt : "Cursor icon"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "100%",
                viewBox: "0 0 108 67",
                height: "100%",
                fill: "none",
                preserveAspectRatio: "xMinYMid",
                className: "__shift-lab-icon-cursor ".concat(animated && "__shift-lab-svg-animate-blink"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        className: "".concat(animated && "__shift-lab-svg-animate-blink"),
                        d: "M60.34,64.73h47.47v-20H60.34Z",
                        fill: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getThemeColor */ .pe)(color)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                        fill: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getThemeColor */ .pe)(color),
                        points: "47.84 33.57 47.7 33.43 47.7 33.43 14.27 0 0.14 14.13 19.43 33.43 0 52.87 14.13 67 47.84 33.57"
                    })
                ]
            })
        ]
    });
};
var IconClose = function(param) {
    var alt = param.alt, _color = param.color, color = _color === void 0 ? "white" : _color, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? "" : _customStyles;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
        customStyles: customStyles,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "100%",
            height: "100%",
            viewBox: "0 0 42 42",
            fill: "none",
            preserveAspectRatio: "xMinYMid",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: alt ? alt : "Close icon"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M33.6982 5L36.5267 7.82843L6.82818 37.5269L3.99976 34.6985L33.6982 5Z",
                    fill: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getThemeColor */ .pe)(color)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M4 7.82861L6.82843 5.00019L36.5269 34.6987L33.6985 37.5271L4 7.82861Z",
                    fill: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getThemeColor */ .pe)(color)
                })
            ]
        })
    });
};
var IconX = function(param) {
    var alt = param.alt, _color = param.color, color = _color === void 0 ? "white" : _color, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? "" : _customStyles;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
        customStyles: customStyles,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "100%",
            height: "100%",
            viewBox: "0 0 222 222",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMid",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: alt ? alt : "X icon"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M47.2097 0L0.46284 46.834L64.2852 110.764L0 175.166L46.7469 222L158.25 111.228L47.2097 0Z",
                    fill: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getThemeColor */ .pe)(color)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M174.79 0L221.537 46.834L157.715 110.764L222 175.166L175.253 222L63.75 111.228L174.79 0Z",
                    fill: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getThemeColor */ .pe)(color)
                })
            ]
        })
    });
};
var IconMobileMenuOpen = function(param) {
    var alt = param.alt, _color = param.color, color = _color === void 0 ? "white" : _color, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? "" : _customStyles;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
        customStyles: customStyles,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "100%",
            height: "100%",
            viewBox: "0 0 42 42",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMid",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: alt ? alt : "Open mobile menu icon"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M38 0H42V42H38V0Z",
                    fill: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getThemeColor */ .pe)(color)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    x: "12",
                    width: "4",
                    height: "100%",
                    fill: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getThemeColor */ .pe)(color)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    width: "4",
                    height: "100%",
                    fill: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getThemeColor */ .pe)(color)
                })
            ]
        })
    });
};
var IconArrow = function(param) {
    var alt = param.alt, _color = param.color, color = _color === void 0 ? "white" : _color, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? "" : _customStyles;
    return /*#__PURE__*/ _jsx(Icon, {
        customStyles: customStyles,
        children: /*#__PURE__*/ _jsxs("svg", {
            width: "100%",
            height: "100%",
            viewBox: "0 0 54 48",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMid",
            children: [
                /*#__PURE__*/ _jsx("title", {
                    children: alt ? alt : "Arrow icon"
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M27.0559 0L26.9431 0.110322L0 36.6448L11.3913 47.8897L26.9431 40.4902L42.6077 48L54 36.7551L27.0559 0Z",
                    fill: getThemeColor(color)
                })
            ]
        })
    });
};
var IconDesktopComputer = function(param) {
    var alt = param.alt, _color = param.color, color = _color === void 0 ? "white" : _color, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? "" : _customStyles;
    return /*#__PURE__*/ _jsx(Icon, {
        customStyles: customStyles,
        children: /*#__PURE__*/ _jsxs("svg", {
            width: "100%",
            height: "100%",
            viewBox: "0 0 48 56",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMid",
            children: [
                /*#__PURE__*/ _jsx("title", {
                    children: alt ? alt : "Desktop computer icon"
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8 31.999H39.999V0H8V31.999Z",
                    fill: getThemeColor(color)
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0 55.999H48V39.999H0V55.999Z",
                    fill: getThemeColor(color)
                })
            ]
        })
    });
};
var IconEnvelope = function(param) {
    var alt = param.alt, _color = param.color, color = _color === void 0 ? "white" : _color, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? "" : _customStyles;
    return /*#__PURE__*/ _jsx(Icon, {
        customStyles: customStyles,
        children: /*#__PURE__*/ _jsxs("svg", {
            width: "100%",
            height: "100%",
            viewBox: "0 0 60 48",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMid",
            children: [
                /*#__PURE__*/ _jsx("title", {
                    children: alt ? alt : "Envelope icon"
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0 48H60V0H0V48ZM8 14.399V6H52V14.399L30 29.411L8 14.399Z",
                    fill: getThemeColor(color)
                })
            ]
        })
    });
};
var IconMobileDevice = function(param) {
    var alt = param.alt, _color = param.color, color = _color === void 0 ? "white" : _color, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? "" : _customStyles;
    return /*#__PURE__*/ _jsx(Icon, {
        customStyles: customStyles,
        children: /*#__PURE__*/ _jsxs("svg", {
            width: "100%",
            height: "100%",
            viewBox: "0 0 40 60",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMid",
            children: [
                /*#__PURE__*/ _jsx("title", {
                    children: alt ? alt : "Mobile device icon"
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0 60H40V0H0V60ZM16 51.9999H24V43.9997H16V51.9999Z",
                    fill: getThemeColor(color)
                })
            ]
        })
    });
};
var IconMonitor = function(param) {
    var alt = param.alt, _color = param.color, color = _color === void 0 ? "white" : _color, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? "" : _customStyles;
    return /*#__PURE__*/ _jsx(Icon, {
        customStyles: customStyles,
        children: /*#__PURE__*/ _jsxs("svg", {
            width: "100%",
            height: "100%",
            viewBox: "0 0 60 56",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMid",
            children: [
                /*#__PURE__*/ _jsx("title", {
                    children: alt ? alt : "Desktop monitor icon"
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0 40H60V0H0V40Z",
                    fill: getThemeColor(color)
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11 56H49.001V48H11V56Z",
                    fill: getThemeColor(color)
                })
            ]
        })
    });
};
var IconPhone = function(param) {
    var alt = param.alt, _color = param.color, color = _color === void 0 ? "white" : _color, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? "" : _customStyles;
    return /*#__PURE__*/ _jsx(Icon, {
        customStyles: customStyles,
        children: /*#__PURE__*/ _jsxs("svg", {
            width: "100%",
            height: "100%",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 55.02 55.02",
            preserveAspectRatio: "xMinYMid",
            children: [
                /*#__PURE__*/ _jsx("title", {
                    children: alt ? alt : "Phone icon"
                }),
                /*#__PURE__*/ _jsx("path", {
                    fill: getThemeColor(color),
                    d: "M52.96,38.05l-12.8-2.97-4.23,4.23c-8.92-4.35-16.14-11.63-20.4-20.6l4.26-4.26-2.81-12.4L14.86,0H2.13C1.3,.85,.83,1.33,0,2.18,1.12,30.81,24.21,53.9,52.84,55.02c.85-.83,1.33-1.3,2.18-2.13v-12.72l-2.06-2.11Z"
                })
            ]
        })
    });
};
var IcoMonitor = function(param) {
    var alt = param.alt, _color = param.color, color = _color === void 0 ? "white" : _color, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? "" : _customStyles;
    return /*#__PURE__*/ _jsx(Icon, {
        customStyles: customStyles,
        children: /*#__PURE__*/ _jsxs("svg", {
            width: "100%",
            height: "100%",
            viewBox: "0 0 60 56",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMid",
            children: [
                /*#__PURE__*/ _jsx("title", {
                    children: alt ? alt : "Monitor icon"
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0 40H60V0H0V40Z",
                    fill: getThemeColor(color)
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11 56H49.001V48H11V56Z",
                    fill: getThemeColor(color)
                })
            ]
        })
    });
};
var IconPlay = function(param) {
    var alt = param.alt, _color = param.color, color = _color === void 0 ? "white" : _color, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? "" : _customStyles;
    return /*#__PURE__*/ _jsx(Icon, {
        customStyles: customStyles,
        children: /*#__PURE__*/ _jsxs("svg", {
            width: "100%",
            height: "100%",
            viewBox: "0 0 55 69",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMid",
            children: [
                /*#__PURE__*/ _jsx("title", {
                    children: alt ? alt : "Play icon"
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0 0V69L55 34.4995L0 0Z",
                    fill: getThemeColor(color)
                })
            ]
        })
    });
};
var IconPlus = function(param) {
    var alt = param.alt, _color = param.color, color = _color === void 0 ? "white" : _color, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? "" : _customStyles;
    return /*#__PURE__*/ _jsx(Icon, {
        customStyles: customStyles,
        children: /*#__PURE__*/ _jsxs("svg", {
            width: "100%",
            height: "100%",
            viewBox: "0 0 60 60",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMid",
            children: [
                /*#__PURE__*/ _jsx("title", {
                    children: alt ? alt : "Plus icon"
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0.000976562 34H60.001V26H0.000976562V34Z",
                    fill: getThemeColor(color)
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M34.001 60V0H26.001L26.001 60H34.001Z",
                    fill: getThemeColor(color)
                })
            ]
        })
    });
};
var IconWatch = function(param) {
    var alt = param.alt, _color = param.color, color = _color === void 0 ? "white" : _color, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? "" : _customStyles;
    return /*#__PURE__*/ _jsx(Icon, {
        customStyles: customStyles,
        children: /*#__PURE__*/ _jsxs("svg", {
            width: "100%",
            height: "100%",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 44 72",
            preserveAspectRatio: "xMinYMid",
            children: [
                /*#__PURE__*/ _jsx("title", {
                    children: alt ? alt : "Watch icon"
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M6,8h32V0H6V8Z",
                    fill: getThemeColor(color)
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M6,72h32v-8H6v8Z",
                    fill: getThemeColor(color)
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M0,14V58H44V14H0Zm32,27h-14V23h8v10h6v8Z",
                    fill: getThemeColor(color)
                })
            ]
        })
    });
};


/***/ }),

/***/ 6270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/Buttons.tsx
var Buttons = __webpack_require__(3739);
// EXTERNAL MODULE: ./components/Grid.tsx
var Grid = __webpack_require__(7504);
// EXTERNAL MODULE: ./components/Spacing.tsx
var Spacing = __webpack_require__(6435);
// EXTERNAL MODULE: ./components/Typography.tsx
var Typography = __webpack_require__(7734);
// EXTERNAL MODULE: ./content/default-content.ts
var default_content = __webpack_require__(4132);
// EXTERNAL MODULE: ./utils/helpers.tsx
var helpers = __webpack_require__(7479);
;// CONCATENATED MODULE: ./components/Footer.tsx









var Footer = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: "bg-black",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                size: "2xl"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* GridContainer */.T5, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-span-full md:col-span-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid grid-cols-6 ".concat(Grid/* gridGutter.mobile */.X$.mobile, " ").concat(Grid/* gridGutter.desktop */.X$.desktop),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "lowercase opacity-50 col-span-full xl:col-span-2 xl:opacity-100",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* H4Display */.rd, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Contact"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* StaticSpacer */.rj, {
                                                size: "md"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-span-full m:col-span-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* H4Display */.rd, {
                                            children: default_content/* contactItems.map */.Wf.map(function(item, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: item.label
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "__shift-lab-typography-text-inline-link",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                dangerouslySetInnerHTML: {
                                                                    __html: item.text
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                                            size: "xl"
                                                        })
                                                    ]
                                                }, "ContactItem_".concat(i));
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-span-full lg:col-span-6 lg:col-start-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid grid-cols-6 ".concat(Grid/* gridGutter.mobile */.X$.mobile, " ").concat(Grid/* gridGutter.desktop */.X$.desktop),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "lowercase opacity-50 col-span-full xl:col-span-2 xl:opacity-100",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* H4Display */.rd, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Headquarters"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* StaticSpacer */.rj, {
                                                size: "md"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-span-full m:col-span-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* H4Display */.rd, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "New York"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                className: "__shift-lab-typography-text-inline-link",
                                                                target: "_blank",
                                                                href: "https://goo.gl/maps/4hDwNe9a3nA3TQhd9",
                                                                rel: "noreferrer",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: "290 5th Ave Fl 4"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: "New York, NY 10001"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: "Between 30th & 31st"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                                size: "xl"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "lowercase opacity-50 col-span-full xl:col-span-2 xl:opacity-100",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* H4Display */.rd, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Social"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* StaticSpacer */.rj, {
                                                size: "md"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-span-full m:col-span-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* H4Display */.rd, {
                                                children: default_content/* socialItems.map */.aZ.map(function(item, i) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            target: "_blank",
                                                            href: item.href,
                                                            rel: "noreferrer",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "__shift-lab-typography-text-inline-link",
                                                                children: item.text
                                                            })
                                                        })
                                                    }, "SocialItem_".concat(i));
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                                size: "xl"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* GridContainer */.T5, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "order-1 lg:order-0 col-span-full lg:col-span-7",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-base md:text-body",
                                children: [
                                    "\xa9 Shift Lab ",
                                    helpers/* currentYear */.VK,
                                    ". All rights reserved."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* StaticSpacer */.rj, {
                                size: "lg"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:order-1 order-0 col-span-full md:col-span-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid grid-cols-6 ".concat(Grid/* gridGutter.mobile */.X$.mobile, " ").concat(Grid/* gridGutter.desktop */.X$.desktop),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-span-full xl:col-span-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-base opacity-50 md:text-body xl:opacity-100",
                                            children: "Proud member of"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* StaticSpacer */.rj, {
                                            size: "xs"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-span-full lg:col-span-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex space-x-12",
                                            children: default_content/* tradeOrgItems.map */.S2.map(function(item, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* Button */.z, {
                                                    noBorder: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        target: "_blank",
                                                        href: item.href,
                                                        rel: "noreferrer",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            alt: item.text,
                                                            src: item.imagePath,
                                                            width: item.imageSize.width,
                                                            height: item.imageSize.height
                                                        })
                                                    })
                                                }, "TradeOrgItem_".concat(i));
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* StaticSpacer */.rj, {
                                            size: "md"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/lottie-react/build/index.umd.js
var index_umd = __webpack_require__(9260);
var index_umd_default = /*#__PURE__*/__webpack_require__.n(index_umd);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/Icons.tsx
var Icons = __webpack_require__(436);
// EXTERNAL MODULE: ./components/Logos.tsx
var Logos = __webpack_require__(7343);
;// CONCATENATED MODULE: ./content/shift-lab-animated-logo-black-bg.json
var shift_lab_animated_logo_black_bg_namespaceObject = JSON.parse('{"assets":[{"id":"UISLIODfXniIlWq0IzFkK","layers":[{"ddd":0,"ind":2,"ty":4,"ln":"layer_2","sr":1,"ks":{"a":{"a":0,"k":[7.125,49.875]},"o":{"a":1,"k":[{"t":0,"s":[0],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":65,"s":[0],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":66,"s":[8.13],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":67,"s":[19.27],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":68,"s":[30.4],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":69,"s":[41.53],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":70,"s":[52.67],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":71,"s":[63.8],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":72,"s":[74.93],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":73,"s":[86.07],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":74,"s":[97.2],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":75,"s":[100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]},"p":{"a":1,"k":[{"t":0,"s":[6395.75,6401.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":65,"s":[6395.75,6401.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":66,"s":[6361.6,6401.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":67,"s":[6327,6401.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":68,"s":[6304.41,6401.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":69,"s":[6291.58,6401.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":70,"s":[6286.28,6401.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":71,"s":[6286.27,6401.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":72,"s":[6289.31,6401.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":73,"s":[6293.18,6401.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":74,"s":[6295.62,6401.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":75,"s":[6295.75,6401.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]},"r":{"a":0,"k":0},"s":{"a":0,"k":[154.39,152.38]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}},"ao":0,"ip":0,"op":599,"st":0,"bm":0,"shapes":[{"ty":"gr","nm":"surface3171","it":[{"ty":"gr","it":[{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,-6.96],[-6.85,-5.02],[-0.35,-0.24],[0,0],[1.6,-2.36]],"o":[[-3.77,5.54],[0,10.96],[0.34,0.25],[0,0],[-2.14,1.92],[0,0]],"v":[[8.39,6.64],[2.74,25.39],[13.02,49.36],[14.07,50.08],[14.07,0.28],[8.39,6.64]]}}},{"ty":"fl","c":{"a":0,"k":[1,1,1,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"gr","it":[{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[-2.93,-2.47],[0,0],[0,0],[-4.22,-6.28]],"o":[[2.11,3.13],[0,0],[0,0],[0.11,7.88],[0,0]],"v":[[6.5,90.8],[14.06,99.2],[14.06,69.57],[0,69.57],[6.5,90.8]]}}},{"ty":"fl","c":{"a":0,"k":[1,1,1,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]}]},{"ddd":0,"ind":3,"ty":4,"ln":"layer_3","sr":1,"ks":{"a":{"a":0,"k":[18.75,60.375]},"o":{"a":1,"k":[{"t":0,"s":[0],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":58,"s":[0],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":59,"s":[3.53],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":60,"s":[14.67],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":61,"s":[25.8],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":62,"s":[36.93],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":63,"s":[48.07],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":64,"s":[59.2],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":65,"s":[70.33],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":66,"s":[81.47],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":67,"s":[92.6],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":68,"s":[100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]},"p":{"a":1,"k":[{"t":0,"s":[6436.25,6400.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":58,"s":[6436.25,6400.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":59,"s":[6420.43,6400.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":60,"s":[6380.22,6400.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":61,"s":[6352.93,6400.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":62,"s":[6336.34,6400.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":63,"s":[6328.2,6400.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":64,"s":[6326.27,6400.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":65,"s":[6328.33,6400.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":66,"s":[6332.13,6400.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":67,"s":[6335.43,6400.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":68,"s":[6336.25,6400.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]},"r":{"a":0,"k":0},"s":{"a":0,"k":[160,159.01]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}},"ao":0,"ip":0,"op":599,"st":0,"bm":0,"shapes":[{"ty":"gr","nm":"surface3176","it":[{"ty":"gr","it":[{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,3.08],[-3.36,2.29],[-1.2,0.48],[0,0],[3.94,-1.83],[3.77,-5.54],[0,-6.96],[-6.85,-5.02],[-9.89,-2.29],[0,0],[1.36,1.18]],"o":[[-2.12,-1.83],[0,-4.34],[1.01,-0.68],[0,0],[-4.49,0.76],[-6.74,3.14],[-3.77,5.54],[0,10.96],[5.98,4.39],[0,0],[-2.1,-0.84],[0,0]],"v":[[32.16,41.37],[28.99,34.01],[34.04,24.08],[37.39,22.37],[37.39,0.3],[24.71,4.13],[8.96,17.14],[3.3,35.89],[13.58,59.86],[37.39,69.88],[37.39,44.39],[32.16,41.37]]}}},{"ty":"fl","c":{"a":0,"k":[1,1,1,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"gr","it":[{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0.57,5.94],[0,0],[-4.22,-6.28],[-7.54,-3.6],[-4.54,-0.9],[0,0],[1.24,1.02]],"o":[[-4.51,-3.7],[0,0],[0.11,7.88],[4.22,6.28],[3.91,1.87],[0,0],[-1.45,-0.73],[0,0]],"v":[[33.35,94.88],[25.73,80.06],[0.56,80.06],[7.07,101.3],[24.7,116.11],[37.38,120.25],[37.38,97.49],[33.35,94.88]]}}},{"ty":"fl","c":{"a":0,"k":[1,1,1,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]}]},{"ddd":0,"ind":4,"ty":4,"ln":"layer_4","sr":1,"ks":{"a":{"a":0,"k":[48.75,61.125]},"o":{"a":1,"k":[{"t":0,"s":[0],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":34,"s":[0],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":35,"s":[0.03],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":36,"s":[0.11],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":37,"s":[0.25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":38,"s":[0.48],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":39,"s":[0.83],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":40,"s":[1.31],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":41,"s":[1.96],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":42,"s":[2.78],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":43,"s":[3.8],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":44,"s":[5.05],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":45,"s":[6.55],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":46,"s":[8.31],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":47,"s":[10.37],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":48,"s":[12.74],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":49,"s":[15.45],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":50,"s":[18.52],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":51,"s":[21.97],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":52,"s":[25.82],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":53,"s":[30.1],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":54,"s":[34.83],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":55,"s":[40.03],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":56,"s":[45.72],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":57,"s":[51.93],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":58,"s":[58.68],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":59,"s":[65.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":60,"s":[73.88],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":61,"s":[82.37],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":62,"s":[91.49],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":63,"s":[100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]},"p":{"a":1,"k":[{"t":0,"s":[6384.75,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":62,"s":[6384.75,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":63,"s":[6386.88,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":64,"s":[6401.05,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":65,"s":[6410.82,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":66,"s":[6416.91,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":67,"s":[6420.07,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":68,"s":[6421.05,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":69,"s":[6420.56,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":70,"s":[6419.36,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":71,"s":[6427.53,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":72,"s":[6434.12,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":73,"s":[6438.6,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":74,"s":[6441.03,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":75,"s":[6441.91,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":76,"s":[6441.73,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":77,"s":[6440.99,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":78,"s":[6440.16,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":79,"s":[6439.75,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]},"r":{"a":0,"k":0},"s":{"a":0,"k":[156.92,157.06]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}},"ao":0,"ip":0,"op":599,"st":0,"bm":0,"shapes":[{"ty":"gr","nm":"surface3181","it":[{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[-4.51,-3.71],[-7.3,0],[-3.71,2.46],[0,4.45],[2.11,1.82],[3.76,1.03],[7.77,1.48],[6.85,5.03],[0,10.96],[-3.77,5.54],[-6.73,3.14],[-8.33,0],[-7.08,-3.36],[-4.11,-5.88],[-0.12,-7.3],[0,0],[4,3.25],[6.16,0],[3.37,-2.28],[0,-4.34],[-2.11,-1.83],[-3.88,-1.02],[-7.54,-1.37],[-5.54,-2.34],[-3.43,-4.62],[0,-7.54],[4.05,-5.76],[7.02,-3.25],[8.68,0],[7.54,3.59],[4.22,6.28],[0.11,7.88]],"o":[[0.57,5.94],[4.51,3.71],[5.93,0],[3.71,-2.45],[0,-3.2],[-2.12,-1.82],[-3.77,-1.02],[-11.98,-2.28],[-6.85,-5.02],[0,-6.96],[3.77,-5.54],[6.73,-3.13],[9.02,0],[7.08,3.37],[4.11,5.88],[0,0],[-0.57,-5.14],[-4,-3.25],[-5.48,0],[-3.37,2.29],[0,3.08],[2.11,1.82],[3.88,1.03],[7.88,1.48],[5.54,2.34],[3.42,4.62],[0,7.19],[-4.05,5.77],[-7.02,3.25],[-9.81,0],[-7.53,-3.6],[-4.23,-6.28],[0,0]],"v":[[25.8,80.82],[33.42,95.63],[51.14,101.19],[65.61,97.51],[71.18,87.15],[68.01,79.62],[59.19,75.34],[41.89,71.57],[13.64,60.61],[3.37,36.64],[9.02,17.89],[24.77,4.88],[47.38,0.17],[71.52,5.22],[88.3,19.09],[94.63,38.87],[69.46,38.87],[62.61,26.28],[47.38,21.4],[34.11,24.83],[29.05,34.76],[32.22,42.12],[41.21,46.4],[58.33,50],[78.45,55.73],[91.89,66.18],[97.03,84.41],[90.95,103.84],[74.34,117.37],[50.8,122.25],[24.77,116.86],[7.14,102.05],[0.63,80.82]]}}},{"ty":"fl","c":{"a":0,"k":[1,1,1,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]}]}]},{"id":"qS8LaOFbn0Og-y_qln_lC","layers":[{"ddd":0,"ind":6,"ty":4,"nm":"","ln":"7FO67F6HNmrkXc8M4s34O","sr":1,"ks":{"a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":1,"k":[{"t":0,"s":[6516.5,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":106,"s":[6516.5,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":107,"s":[6534.86,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":108,"s":[6575.26,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":109,"s":[6610.23,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":110,"s":[6640.13,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":111,"s":[6665.32,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":112,"s":[6686.17,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":113,"s":[6703.01,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":114,"s":[6716.22,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":115,"s":[6726.16,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":116,"s":[6733.18,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":117,"s":[6737.63,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":118,"s":[6739.89,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":119,"s":[6740.3,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":120,"s":[6739.23,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":121,"s":[6737.03,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":122,"s":[6734.06,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":123,"s":[6730.68,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":124,"s":[6727.25,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":125,"s":[6724.12,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":126,"s":[6721.66,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":127,"s":[6720.22,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":128,"s":[6720,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":418,"s":[6720,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":419,"s":[6700.61,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":420,"s":[6660.34,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":421,"s":[6625.5,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":422,"s":[6595.71,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":423,"s":[6570.63,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":424,"s":[6549.89,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":425,"s":[6533.13,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":426,"s":[6520,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":427,"s":[6510.14,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":428,"s":[6503.19,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":429,"s":[6498.79,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":430,"s":[6496.58,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":431,"s":[6496.21,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":432,"s":[6497.31,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":433,"s":[6499.54,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":434,"s":[6502.52,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":435,"s":[6505.91,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":436,"s":[6509.33,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":437,"s":[6512.45,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":438,"s":[6514.89,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":439,"s":[6516.29,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":440,"s":[6516.5,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}},"ao":0,"ip":0,"op":599,"st":0,"bm":0,"shapes":[{"ty":"gr","hd":false,"bm":0,"it":[{"ty":"rc","hd":false,"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":1,"k":[{"t":0,"s":[407,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":106,"s":[407,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":107,"s":[370.28,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":108,"s":[289.48,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":109,"s":[219.54,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":110,"s":[159.74,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":111,"s":[109.35,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":112,"s":[67.67,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":113,"s":[33.97,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":114,"s":[7.55,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":115,"s":[12.32,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":116,"s":[26.35,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":117,"s":[35.27,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":118,"s":[39.78,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":119,"s":[40.6,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":120,"s":[38.45,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":121,"s":[34.05,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":122,"s":[28.11,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":123,"s":[21.35,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":124,"s":[14.49,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":125,"s":[8.24,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":126,"s":[3.32,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":127,"s":[0.45,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":128,"s":[0,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":418,"s":[0,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":419,"s":[38.79,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":420,"s":[119.31,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":421,"s":[189.01,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":422,"s":[248.58,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":423,"s":[298.75,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":424,"s":[340.23,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":425,"s":[373.74,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":426,"s":[400,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":427,"s":[419.72,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":428,"s":[433.63,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":429,"s":[442.42,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":430,"s":[446.84,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":431,"s":[447.58,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":432,"s":[445.37,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":433,"s":[440.92,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":434,"s":[434.96,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":435,"s":[428.19,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":436,"s":[421.33,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":437,"s":[415.11,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":438,"s":[410.23,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":439,"s":[407.41,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":440,"s":[407,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]}},{"ty":"fl","hd":false,"bm":0,"c":{"a":0,"k":[0.063,0.063,0.063]},"r":1,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}],"np":0}]},{"ddd":0,"ind":7,"ty":4,"nm":"","ln":"nr13BIYgz6ULL-vo8LD2A","sr":1,"ks":{"a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[6196.5,6400]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}},"ao":0,"ip":0,"op":599,"st":0,"bm":0,"shapes":[{"ty":"gr","hd":false,"bm":0,"it":[{"ty":"rc","hd":false,"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[233,197]}},{"ty":"fl","hd":false,"bm":0,"c":{"a":0,"k":[0.063,0.063,0.063]},"r":1,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}],"np":0}]},{"ddd":0,"ind":8,"ty":4,"ln":"layer_8","sr":1,"ks":{"a":{"a":0,"k":[225.005,69.375]},"o":{"a":0,"k":100},"p":{"a":0,"k":[6400,6400]},"r":{"a":0,"k":0},"s":{"a":0,"k":[142.22,141.98]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}},"ao":0,"ip":0,"op":599,"st":0,"bm":0,"shapes":[{"ty":"gr","nm":"surface3186","it":[{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-1.25,-1.32],[-3.14,0],[0,0],[0,0],[0,0],[4.57,4.7],[0,9.53]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,3.13],[1.25,1.32],[0,0],[0,0],[0,0],[-9.65,0],[-4.58,-4.7],[0,0]],"v":[[399.25,63.34],[383.28,63.34],[383.28,40.6],[399.25,40.6],[399.25,13.35],[425.75,13.35],[425.75,40.6],[447.75,40.6],[447.75,63.34],[425.75,63.34],[425.75,105.63],[427.63,112.3],[434.21,114.27],[450,114.27],[450,137.21],[427.45,137.21],[406.11,130.16],[399.25,108.82]]}}},{"ty":"fl","c":{"a":0,"k":[0.96,0.96,0.96,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[-4.89,4.7],[-9.77,0],[0,0],[0,0],[0,0],[1.19,-1.12],[0,-2.5],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,-8.9],[4.89,-4.7],[0,0],[0,0],[0,0],[-2.5,0],[-1.2,1.13],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[324.74,40.6],[324.74,33.08],[332.07,12.69],[354.06,5.64],[375.49,5.64],[375.49,28.57],[358.57,28.57],[353.03,30.26],[351.25,35.71],[351.25,40.6],[375.49,40.6],[375.49,63.34],[351.25,63.34],[351.25,137.21],[324.74,137.21],[324.74,63.34],[308.77,63.34],[308.77,40.6]]}}},{"ty":"fl","c":{"a":0,"k":[0.96,0.96,0.96,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[272.94,137.21],[299.44,137.21],[299.44,40.6],[272.94,40.6]]}}},{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,-4.38],[2.94,-2.94],[4.38,0],[3.01,2.95],[0,4.39],[-3.01,2.88],[-4.39,0],[-2.95,-2.88]],"o":[[2.94,2.88],[0,4.39],[-2.95,2.95],[-4.39,0],[-3.01,-2.94],[0,-4.38],[3.01,-2.88],[4.38,0],[0,0]],"v":[[297.28,4.32],[301.7,15.22],[297.28,26.22],[286.29,30.64],[275.2,26.22],[270.68,15.22],[275.2,4.32],[286.29,0],[297.28,4.32]]}}},{"ty":"fl","c":{"a":0,"k":[0.96,0.96,0.96,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,-16.16],[0,0],[0,0],[0,0],[13.03,0],[3.82,-4.57],[0,-8.02],[0,0],[0,0],[0,0],[0,0],[0,0],[-4.45,2],[-6.39,0],[-7.46,-6.96]],"o":[[7.45,6.95],[0,0],[0,0],[0,0],[0,-16.04],[-6.77,0],[-3.82,4.57],[0,0],[0,0],[0,0],[0,0],[0,0],[3.38,-3.63],[4.45,-2],[11.52,0],[0,0]],"v":[[252.26,49.9],[263.44,84.58],[263.44,137.2],[236.94,137.2],[236.94,85.89],[217.39,61.84],[201.51,68.7],[195.78,87.59],[195.78,137.2],[169.28,137.2],[169.28,5.64],[195.78,5.64],[195.78,50.93],[207.52,42.48],[223.79,39.47],[252.26,49.9]]}}},{"ty":"fl","c":{"a":0,"k":[0.96,0.96,0.96,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,-7.64],[-7.52,-5.51],[-0.39,-0.27],[0,0],[1.76,-2.59]],"o":[[-4.14,6.08],[0,12.02],[0.37,0.27],[0,0],[-2.35,2.11],[0,0]],"v":[[9.21,23.75],[3.01,44.33],[14.28,70.63],[15.44,71.43],[15.44,16.76],[9.21,23.75]]}}},{"ty":"fl","c":{"a":0,"k":[0.96,0.96,0.96,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[-3.22,-2.71],[0,0],[0,0],[-4.63,-6.89]],"o":[[2.31,3.44],[0,0],[0,0],[0.12,8.64],[0,0]],"v":[[7.14,116.11],[15.43,125.32],[15.43,92.81],[0,92.81],[7.14,116.11]]}}},{"ty":"fl","c":{"a":0,"k":[0.96,0.96,0.96,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,3.38],[-3.7,2.51],[-1.32,0.52],[0,0],[4.32,-2.01],[4.13,-6.07],[0,-7.64],[-7.52,-5.51],[-10.86,-2.52],[0,0],[1.5,1.29]],"o":[[-2.32,-2],[0,-4.76],[1.11,-0.75],[0,0],[-4.93,0.84],[-7.4,3.45],[-4.13,6.08],[0,12.02],[6.56,4.81],[0,0],[-2.3,-0.93],[0,0]],"v":[[50.1,50.34],[46.63,42.26],[52.17,31.36],[55.84,29.49],[55.84,5.27],[41.93,9.47],[24.64,23.75],[18.44,44.33],[29.71,70.64],[55.84,81.63],[55.84,53.65],[50.1,50.34]]}}},{"ty":"fl","c":{"a":0,"k":[0.96,0.96,0.96,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0.63,6.52],[0,0],[-4.64,-6.89],[-8.27,-3.95],[-4.97,-0.98],[0,0],[1.36,1.12]],"o":[[-4.95,-4.07],[0,0],[0.12,8.64],[4.63,6.89],[4.3,2.05],[0,0],[-1.59,-0.81],[0,0]],"v":[[51.41,109.06],[43.05,92.81],[15.43,92.81],[22.57,116.11],[41.93,132.37],[55.84,136.91],[55.84,111.94],[51.41,109.06]]}}},{"ty":"fl","c":{"a":0,"k":[0.96,0.96,0.96,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"gr","it":[{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[-4.95,-4.07],[-8.02,0],[-4.07,2.7],[0,4.89],[2.31,2],[4.13,1.13],[8.52,1.63],[7.52,5.52],[0,12.02],[-4.14,6.08],[-7.39,3.45],[-9.14,0],[-7.77,-3.69],[-4.51,-6.45],[-0.13,-8.02],[0,0],[4.39,3.57],[6.76,0],[3.7,-2.5],[0,-4.76],[-2.32,-2],[-4.26,-1.12],[-8.27,-1.5],[-6.08,-2.57],[-3.76,-5.07],[0,-8.27],[4.45,-6.32],[7.7,-3.57],[9.52,0],[8.27,3.95],[4.63,6.89],[0.12,8.64]],"o":[[0.62,6.52],[4.95,4.07],[6.51,0],[4.07,-2.69],[0,-3.51],[-2.32,-2.01],[-4.13,-1.12],[-13.15,-2.5],[-7.52,-5.51],[0,-7.64],[4.13,-6.07],[7.39,-3.44],[9.89,0],[7.77,3.7],[4.51,6.45],[0,0],[-0.63,-5.64],[-4.39,-3.57],[-6.02,0],[-3.7,2.51],[0,3.39],[2.31,2],[4.26,1.13],[8.65,1.63],[6.07,2.57],[3.75,5.07],[0,7.89],[-4.45,6.33],[-7.71,3.57],[-10.77,0],[-8.27,-3.95],[-4.63,-6.89],[0,0]],"v":[[83.46,92.81],[91.82,109.07],[111.27,115.18],[127.15,111.13],[133.26,99.77],[129.78,91.5],[120.1,86.8],[101.12,82.66],[70.12,70.64],[58.84,44.33],[65.05,23.75],[82.33,9.47],[107.14,4.3],[133.63,9.85],[152.05,25.07],[159,46.77],[131.38,46.77],[123.86,32.96],[107.14,27.61],[92.57,31.36],[87.03,42.26],[90.51,50.34],[100.37,55.04],[119.16,58.99],[141.25,65.28],[156,76.75],[161.63,96.76],[154.96,118.09],[136.73,132.93],[110.89,138.29],[82.33,132.37],[62.98,116.11],[55.84,92.81]]}}},{"ty":"fl","c":{"a":0,"k":[0.96,0.96,0.96,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]}]}]}],"ddd":0,"fr":60,"h":197,"ip":0,"layers":[{"ddd":0,"ind":1,"ty":0,"nm":"","ln":"precomp_96x7FIy_1eDSIaMod-Y4b1","sr":1,"ks":{"a":{"a":0,"k":[6400,6400]},"o":{"a":0,"k":100},"p":{"a":0,"k":[115.75,100.5]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}},"ao":0,"w":12800,"h":12800,"ip":0,"op":599,"st":0,"bm":0,"refId":"UISLIODfXniIlWq0IzFkK"},{"ddd":0,"ind":5,"ty":0,"nm":"","ln":"precomp_xfYbVSdprPsBDyugISBrU5","sr":1,"ks":{"a":{"a":0,"k":[6400,6400]},"o":{"a":0,"k":100},"p":{"a":0,"k":[320,98.5]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}},"ao":0,"w":12800,"h":12800,"ip":0,"op":599,"st":0,"bm":0,"refId":"qS8LaOFbn0Og-y_qln_lC"},{"ddd":0,"ind":9,"ty":4,"nm":"","ln":"63zFQZV_7WxZnASN0o9hU","sr":1,"ks":{"a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[320,98.5]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}},"ao":0,"ip":0,"op":599,"st":0,"bm":0,"shapes":[{"ty":"gr","hd":false,"bm":0,"it":[{"ty":"rc","hd":false,"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[640,197]}},{"ty":"fl","hd":false,"bm":0,"c":{"a":0,"k":[0.063,0.063,0.063]},"r":1,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}],"np":0}]}],"meta":{"g":"https://jitter.video"},"nm":"shift-lab-animated-logo-black-bg","op":599,"v":"5.7.4","w":640}');
;// CONCATENATED MODULE: ./content/shift-lab-animated-logo-white-bg.json
var shift_lab_animated_logo_white_bg_namespaceObject = JSON.parse('{"assets":[{"id":"ZRyvIWADUFNKAqRht0_XM","layers":[{"ddd":0,"ind":2,"ty":4,"ln":"layer_2","sr":1,"ks":{"a":{"a":0,"k":[7.125,49.875]},"o":{"a":1,"k":[{"t":0,"s":[0],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":65,"s":[0],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":66,"s":[8.13],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":67,"s":[19.27],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":68,"s":[30.4],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":69,"s":[41.53],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":70,"s":[52.67],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":71,"s":[63.8],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":72,"s":[74.93],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":73,"s":[86.07],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":74,"s":[97.2],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":75,"s":[100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]},"p":{"a":1,"k":[{"t":0,"s":[6395.75,6401.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":65,"s":[6395.75,6401.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":66,"s":[6361.6,6401.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":67,"s":[6327,6401.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":68,"s":[6304.41,6401.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":69,"s":[6291.58,6401.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":70,"s":[6286.28,6401.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":71,"s":[6286.27,6401.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":72,"s":[6289.31,6401.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":73,"s":[6293.18,6401.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":74,"s":[6295.62,6401.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":75,"s":[6295.75,6401.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]},"r":{"a":0,"k":0},"s":{"a":0,"k":[154.39,152.38]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}},"ao":0,"ip":0,"op":599,"st":0,"bm":0,"shapes":[{"ty":"gr","nm":"surface3809","it":[{"ty":"gr","it":[{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,-6.96],[-6.85,-5.02],[-0.35,-0.24],[0,0],[1.6,-2.36]],"o":[[-3.77,5.54],[0,10.96],[0.34,0.25],[0,0],[-2.14,1.92],[0,0]],"v":[[8.39,6.64],[2.74,25.39],[13.02,49.36],[14.07,50.08],[14.07,0.28],[8.39,6.64]]}}},{"ty":"fl","c":{"a":0,"k":[0.06,0.06,0.06,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"gr","it":[{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[-2.93,-2.47],[0,0],[0,0],[-4.22,-6.28]],"o":[[2.11,3.13],[0,0],[0,0],[0.11,7.88],[0,0]],"v":[[6.5,90.8],[14.06,99.2],[14.06,69.57],[0,69.57],[6.5,90.8]]}}},{"ty":"fl","c":{"a":0,"k":[0.06,0.06,0.06,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]}]},{"ddd":0,"ind":3,"ty":4,"ln":"layer_3","sr":1,"ks":{"a":{"a":0,"k":[18.75,60.375]},"o":{"a":1,"k":[{"t":0,"s":[0],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":58,"s":[0],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":59,"s":[3.53],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":60,"s":[14.67],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":61,"s":[25.8],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":62,"s":[36.93],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":63,"s":[48.07],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":64,"s":[59.2],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":65,"s":[70.33],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":66,"s":[81.47],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":67,"s":[92.6],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":68,"s":[100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]},"p":{"a":1,"k":[{"t":0,"s":[6436.25,6400.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":58,"s":[6436.25,6400.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":59,"s":[6420.43,6400.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":60,"s":[6380.22,6400.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":61,"s":[6352.93,6400.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":62,"s":[6336.34,6400.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":63,"s":[6328.2,6400.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":64,"s":[6326.27,6400.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":65,"s":[6328.33,6400.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":66,"s":[6332.13,6400.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":67,"s":[6335.43,6400.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":68,"s":[6336.25,6400.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]},"r":{"a":0,"k":0},"s":{"a":0,"k":[160,159.01]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}},"ao":0,"ip":0,"op":599,"st":0,"bm":0,"shapes":[{"ty":"gr","nm":"surface3814","it":[{"ty":"gr","it":[{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,3.08],[-3.36,2.29],[-1.2,0.48],[0,0],[3.94,-1.83],[3.77,-5.54],[0,-6.96],[-6.85,-5.02],[-9.89,-2.29],[0,0],[1.36,1.18]],"o":[[-2.12,-1.83],[0,-4.34],[1.01,-0.68],[0,0],[-4.49,0.76],[-6.74,3.14],[-3.77,5.54],[0,10.96],[5.98,4.39],[0,0],[-2.1,-0.84],[0,0]],"v":[[32.16,41.37],[28.99,34.01],[34.04,24.08],[37.39,22.37],[37.39,0.3],[24.71,4.13],[8.96,17.14],[3.3,35.89],[13.58,59.86],[37.39,69.88],[37.39,44.39],[32.16,41.37]]}}},{"ty":"fl","c":{"a":0,"k":[0.06,0.06,0.06,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"gr","it":[{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0.57,5.94],[0,0],[-4.22,-6.28],[-7.54,-3.6],[-4.54,-0.9],[0,0],[1.24,1.02]],"o":[[-4.51,-3.7],[0,0],[0.11,7.88],[4.22,6.28],[3.91,1.87],[0,0],[-1.45,-0.73],[0,0]],"v":[[33.35,94.88],[25.73,80.06],[0.56,80.06],[7.07,101.3],[24.7,116.11],[37.38,120.25],[37.38,97.49],[33.35,94.88]]}}},{"ty":"fl","c":{"a":0,"k":[0.06,0.06,0.06,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]}]},{"ddd":0,"ind":4,"ty":4,"ln":"layer_4","sr":1,"ks":{"a":{"a":0,"k":[48.75,61.125]},"o":{"a":1,"k":[{"t":0,"s":[0],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":34,"s":[0],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":35,"s":[0.03],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":36,"s":[0.11],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":37,"s":[0.25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":38,"s":[0.48],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":39,"s":[0.83],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":40,"s":[1.31],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":41,"s":[1.96],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":42,"s":[2.78],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":43,"s":[3.8],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":44,"s":[5.05],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":45,"s":[6.55],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":46,"s":[8.31],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":47,"s":[10.37],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":48,"s":[12.74],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":49,"s":[15.45],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":50,"s":[18.52],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":51,"s":[21.97],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":52,"s":[25.82],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":53,"s":[30.1],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":54,"s":[34.83],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":55,"s":[40.03],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":56,"s":[45.72],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":57,"s":[51.93],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":58,"s":[58.68],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":59,"s":[65.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":60,"s":[73.88],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":61,"s":[82.37],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":62,"s":[91.49],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":63,"s":[100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]},"p":{"a":1,"k":[{"t":0,"s":[6384.75,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":62,"s":[6384.75,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":63,"s":[6386.88,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":64,"s":[6401.05,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":65,"s":[6410.82,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":66,"s":[6416.91,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":67,"s":[6420.07,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":68,"s":[6421.05,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":69,"s":[6420.56,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":70,"s":[6419.36,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":71,"s":[6427.53,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":72,"s":[6434.12,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":73,"s":[6438.6,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":74,"s":[6441.03,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":75,"s":[6441.91,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":76,"s":[6441.73,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":77,"s":[6440.99,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":78,"s":[6440.16,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":79,"s":[6439.75,6399.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]},"r":{"a":0,"k":0},"s":{"a":0,"k":[156.92,157.06]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}},"ao":0,"ip":0,"op":599,"st":0,"bm":0,"shapes":[{"ty":"gr","nm":"surface3819","it":[{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[-4.51,-3.71],[-7.3,0],[-3.71,2.46],[0,4.45],[2.11,1.82],[3.76,1.03],[7.77,1.48],[6.85,5.03],[0,10.96],[-3.77,5.54],[-6.73,3.14],[-8.33,0],[-7.08,-3.36],[-4.11,-5.88],[-0.12,-7.3],[0,0],[4,3.25],[6.16,0],[3.37,-2.28],[0,-4.34],[-2.11,-1.83],[-3.88,-1.02],[-7.53,-1.37],[-5.54,-2.34],[-3.43,-4.62],[0,-7.54],[4.05,-5.76],[7.02,-3.25],[8.68,0],[7.54,3.59],[4.22,6.28],[0.11,7.88]],"o":[[0.57,5.94],[4.51,3.71],[5.93,0],[3.71,-2.45],[0,-3.2],[-2.12,-1.82],[-3.77,-1.02],[-11.98,-2.28],[-6.85,-5.02],[0,-6.96],[3.77,-5.54],[6.73,-3.13],[9.02,0],[7.08,3.37],[4.11,5.88],[0,0],[-0.57,-5.14],[-4,-3.25],[-5.48,0],[-3.37,2.29],[0,3.08],[2.11,1.82],[3.88,1.03],[7.88,1.48],[5.54,2.34],[3.42,4.62],[0,7.19],[-4.05,5.77],[-7.02,3.25],[-9.81,0],[-7.53,-3.6],[-4.23,-6.28],[0,0]],"v":[[25.8,80.82],[33.42,95.63],[51.14,101.19],[65.61,97.51],[71.18,87.15],[68.01,79.62],[59.19,75.34],[41.89,71.57],[13.64,60.61],[3.37,36.64],[9.02,17.89],[24.77,4.88],[47.38,0.17],[71.52,5.22],[88.3,19.09],[94.63,38.87],[69.46,38.87],[62.61,26.28],[47.38,21.4],[34.11,24.83],[29.05,34.76],[32.22,42.12],[41.21,46.4],[58.33,50],[78.45,55.73],[91.89,66.18],[97.03,84.41],[90.95,103.84],[74.34,117.37],[50.8,122.25],[24.77,116.86],[7.14,102.05],[0.63,80.82]]}}},{"ty":"fl","c":{"a":0,"k":[0.06,0.06,0.06,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]}]}]},{"id":"aZDS-kyY0kbcq0zGDZ46J","layers":[{"ddd":0,"ind":6,"ty":4,"nm":"","ln":"7FO67F6HNmrkXc8M4s34O","sr":1,"ks":{"a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":1,"k":[{"t":0,"s":[6516.5,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":106,"s":[6516.5,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":107,"s":[6534.86,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":108,"s":[6575.26,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":109,"s":[6610.23,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":110,"s":[6640.13,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":111,"s":[6665.32,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":112,"s":[6686.17,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":113,"s":[6703.01,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":114,"s":[6716.22,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":115,"s":[6726.16,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":116,"s":[6733.18,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":117,"s":[6737.63,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":118,"s":[6739.89,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":119,"s":[6740.3,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":120,"s":[6739.23,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":121,"s":[6737.03,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":122,"s":[6734.06,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":123,"s":[6730.68,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":124,"s":[6727.25,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":125,"s":[6724.12,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":126,"s":[6721.66,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":127,"s":[6720.22,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":128,"s":[6720,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":418,"s":[6720,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":419,"s":[6700.61,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":420,"s":[6660.34,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":421,"s":[6625.5,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":422,"s":[6595.71,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":423,"s":[6570.63,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":424,"s":[6549.89,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":425,"s":[6533.13,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":426,"s":[6520,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":427,"s":[6510.14,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":428,"s":[6503.19,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":429,"s":[6498.79,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":430,"s":[6496.58,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":431,"s":[6496.21,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":432,"s":[6497.31,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":433,"s":[6499.54,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":434,"s":[6502.52,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":435,"s":[6505.91,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":436,"s":[6509.33,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":437,"s":[6512.45,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":438,"s":[6514.89,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":439,"s":[6516.29,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":440,"s":[6516.5,6400],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}},"ao":0,"ip":0,"op":599,"st":0,"bm":0,"shapes":[{"ty":"gr","hd":false,"bm":0,"it":[{"ty":"rc","hd":false,"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":1,"k":[{"t":0,"s":[407,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":106,"s":[407,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":107,"s":[370.28,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":108,"s":[289.48,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":109,"s":[219.54,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":110,"s":[159.74,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":111,"s":[109.35,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":112,"s":[67.67,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":113,"s":[33.97,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":114,"s":[7.55,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":115,"s":[12.32,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":116,"s":[26.35,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":117,"s":[35.27,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":118,"s":[39.78,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":119,"s":[40.6,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":120,"s":[38.45,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":121,"s":[34.05,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":122,"s":[28.11,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":123,"s":[21.35,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":124,"s":[14.49,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":125,"s":[8.24,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":126,"s":[3.32,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":127,"s":[0.45,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":128,"s":[0,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":418,"s":[0,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":419,"s":[38.79,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":420,"s":[119.31,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":421,"s":[189.01,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":422,"s":[248.58,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":423,"s":[298.75,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":424,"s":[340.23,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":425,"s":[373.74,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":426,"s":[400,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":427,"s":[419.72,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":428,"s":[433.63,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":429,"s":[442.42,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":430,"s":[446.84,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":431,"s":[447.58,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":432,"s":[445.37,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":433,"s":[440.92,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":434,"s":[434.96,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":435,"s":[428.19,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":436,"s":[421.33,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":437,"s":[415.11,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":438,"s":[410.23,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":439,"s":[407.41,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":440,"s":[407,197],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]}},{"ty":"fl","hd":false,"bm":0,"c":{"a":0,"k":[1,1,1]},"r":1,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}],"np":0}]},{"ddd":0,"ind":7,"ty":4,"nm":"","ln":"nr13BIYgz6ULL-vo8LD2A","sr":1,"ks":{"a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[6196.5,6400]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}},"ao":0,"ip":0,"op":599,"st":0,"bm":0,"shapes":[{"ty":"gr","hd":false,"bm":0,"it":[{"ty":"rc","hd":false,"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[233,197]}},{"ty":"fl","hd":false,"bm":0,"c":{"a":0,"k":[1,1,1]},"r":1,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}],"np":0}]},{"ddd":0,"ind":8,"ty":4,"ln":"layer_8","sr":1,"ks":{"a":{"a":0,"k":[225.005,69.375]},"o":{"a":0,"k":100},"p":{"a":0,"k":[6400,6400]},"r":{"a":0,"k":0},"s":{"a":0,"k":[142.22,141.98]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}},"ao":0,"ip":0,"op":599,"st":0,"bm":0,"shapes":[{"ty":"gr","nm":"surface3824","it":[{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-1.25,-1.32],[-3.14,0],[0,0],[0,0],[0,0],[4.57,4.7],[0,9.53]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,3.13],[1.25,1.32],[0,0],[0,0],[0,0],[-9.65,0],[-4.58,-4.7],[0,0]],"v":[[399.25,63.34],[383.28,63.34],[383.28,40.6],[399.25,40.6],[399.25,13.35],[425.75,13.35],[425.75,40.6],[447.75,40.6],[447.75,63.34],[425.75,63.34],[425.75,105.63],[427.63,112.3],[434.21,114.27],[450,114.27],[450,137.21],[427.45,137.21],[406.11,130.16],[399.25,108.82]]}}},{"ty":"fl","c":{"a":0,"k":[0.06,0.06,0.06,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[-4.89,4.7],[-9.77,0],[0,0],[0,0],[0,0],[1.19,-1.12],[0,-2.5],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,-8.9],[4.89,-4.7],[0,0],[0,0],[0,0],[-2.5,0],[-1.2,1.13],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[324.74,40.6],[324.74,33.08],[332.07,12.69],[354.06,5.64],[375.49,5.64],[375.49,28.57],[358.57,28.57],[353.03,30.26],[351.25,35.71],[351.25,40.6],[375.49,40.6],[375.49,63.34],[351.25,63.34],[351.25,137.21],[324.74,137.21],[324.74,63.34],[308.77,63.34],[308.77,40.6]]}}},{"ty":"fl","c":{"a":0,"k":[0.06,0.06,0.06,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[272.94,137.21],[299.44,137.21],[299.44,40.6],[272.94,40.6]]}}},{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,-4.38],[2.94,-2.94],[4.38,0],[3.01,2.95],[0,4.39],[-3.01,2.88],[-4.39,0],[-2.95,-2.88]],"o":[[2.94,2.88],[0,4.39],[-2.95,2.95],[-4.39,0],[-3.01,-2.94],[0,-4.38],[3.01,-2.88],[4.38,0],[0,0]],"v":[[297.28,4.32],[301.7,15.22],[297.28,26.22],[286.29,30.64],[275.2,26.22],[270.68,15.22],[275.2,4.32],[286.29,0],[297.28,4.32]]}}},{"ty":"fl","c":{"a":0,"k":[0.06,0.06,0.06,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,-16.16],[0,0],[0,0],[0,0],[13.03,0],[3.82,-4.57],[0,-8.02],[0,0],[0,0],[0,0],[0,0],[0,0],[-4.45,2],[-6.39,0],[-7.46,-6.96]],"o":[[7.45,6.95],[0,0],[0,0],[0,0],[0,-16.04],[-6.77,0],[-3.82,4.57],[0,0],[0,0],[0,0],[0,0],[0,0],[3.38,-3.63],[4.45,-2],[11.52,0],[0,0]],"v":[[252.26,49.9],[263.44,84.58],[263.44,137.2],[236.94,137.2],[236.94,85.89],[217.39,61.84],[201.51,68.7],[195.78,87.59],[195.78,137.2],[169.28,137.2],[169.28,5.64],[195.78,5.64],[195.78,50.93],[207.52,42.48],[223.79,39.47],[252.26,49.9]]}}},{"ty":"fl","c":{"a":0,"k":[0.06,0.06,0.06,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,-7.64],[-7.52,-5.51],[-0.39,-0.27],[0,0],[1.76,-2.59]],"o":[[-4.14,6.08],[0,12.02],[0.37,0.27],[0,0],[-2.35,2.11],[0,0]],"v":[[9.21,23.75],[3.01,44.33],[14.28,70.63],[15.44,71.43],[15.44,16.76],[9.21,23.75]]}}},{"ty":"fl","c":{"a":0,"k":[0.06,0.06,0.06,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[-3.22,-2.71],[0,0],[0,0],[-4.63,-6.89]],"o":[[2.31,3.44],[0,0],[0,0],[0.12,8.64],[0,0]],"v":[[7.14,116.11],[15.43,125.32],[15.43,92.81],[0,92.81],[7.14,116.11]]}}},{"ty":"fl","c":{"a":0,"k":[0.06,0.06,0.06,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,3.38],[-3.7,2.51],[-1.32,0.52],[0,0],[4.32,-2.01],[4.13,-6.07],[0,-7.64],[-7.52,-5.51],[-10.86,-2.52],[0,0],[1.5,1.29]],"o":[[-2.32,-2],[0,-4.76],[1.11,-0.75],[0,0],[-4.93,0.84],[-7.4,3.45],[-4.13,6.08],[0,12.02],[6.56,4.81],[0,0],[-2.3,-0.93],[0,0]],"v":[[50.1,50.34],[46.63,42.26],[52.17,31.36],[55.84,29.49],[55.84,5.27],[41.93,9.47],[24.64,23.75],[18.44,44.33],[29.71,70.64],[55.84,81.63],[55.84,53.65],[50.1,50.34]]}}},{"ty":"fl","c":{"a":0,"k":[0.06,0.06,0.06,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0.63,6.52],[0,0],[-4.64,-6.89],[-8.27,-3.95],[-4.97,-0.98],[0,0],[1.36,1.12]],"o":[[-4.95,-4.07],[0,0],[0.12,8.64],[4.63,6.89],[4.3,2.05],[0,0],[-1.59,-0.81],[0,0]],"v":[[51.41,109.06],[43.05,92.81],[15.43,92.81],[22.57,116.11],[41.93,132.37],[55.84,136.91],[55.84,111.94],[51.41,109.06]]}}},{"ty":"fl","c":{"a":0,"k":[0.06,0.06,0.06,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"gr","it":[{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[-4.95,-4.07],[-8.02,0],[-4.07,2.7],[0,4.89],[2.31,2],[4.13,1.13],[8.52,1.63],[7.52,5.52],[0,12.02],[-4.14,6.08],[-7.39,3.45],[-9.14,0],[-7.77,-3.69],[-4.51,-6.45],[-0.13,-8.02],[0,0],[4.39,3.57],[6.76,0],[3.7,-2.5],[0,-4.76],[-2.32,-2],[-4.26,-1.12],[-8.27,-1.5],[-6.08,-2.57],[-3.76,-5.07],[0,-8.27],[4.45,-6.32],[7.7,-3.57],[9.52,0],[8.27,3.95],[4.63,6.89],[0.12,8.64]],"o":[[0.62,6.52],[4.95,4.07],[6.51,0],[4.07,-2.69],[0,-3.51],[-2.32,-2.01],[-4.13,-1.12],[-13.15,-2.5],[-7.52,-5.51],[0,-7.64],[4.13,-6.07],[7.39,-3.44],[9.89,0],[7.77,3.7],[4.51,6.45],[0,0],[-0.63,-5.64],[-4.39,-3.57],[-6.02,0],[-3.7,2.51],[0,3.39],[2.31,2],[4.26,1.13],[8.65,1.63],[6.07,2.57],[3.75,5.07],[0,7.89],[-4.45,6.33],[-7.71,3.57],[-10.77,0],[-8.27,-3.95],[-4.63,-6.89],[0,0]],"v":[[83.46,92.81],[91.82,109.07],[111.27,115.18],[127.15,111.13],[133.26,99.77],[129.78,91.5],[120.1,86.8],[101.12,82.66],[70.12,70.64],[58.84,44.33],[65.05,23.75],[82.33,9.47],[107.14,4.3],[133.63,9.85],[152.05,25.07],[159,46.77],[131.38,46.77],[123.86,32.96],[107.14,27.61],[92.57,31.36],[87.03,42.26],[90.51,50.34],[100.37,55.04],[119.16,58.99],[141.25,65.28],[156,76.75],[161.63,96.76],[154.96,118.09],[136.73,132.93],[110.89,138.29],[82.33,132.37],[62.98,116.11],[55.84,92.81]]}}},{"ty":"fl","c":{"a":0,"k":[0.06,0.06,0.06,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]}]}]}],"ddd":0,"fr":60,"h":197,"ip":0,"layers":[{"ddd":0,"ind":1,"ty":0,"nm":"","ln":"precomp_96x7FIy_1eDSIaMod-Y4b1","sr":1,"ks":{"a":{"a":0,"k":[6400,6400]},"o":{"a":0,"k":100},"p":{"a":0,"k":[115.75,100.5]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}},"ao":0,"w":12800,"h":12800,"ip":0,"op":599,"st":0,"bm":0,"refId":"ZRyvIWADUFNKAqRht0_XM"},{"ddd":0,"ind":5,"ty":0,"nm":"","ln":"precomp_xfYbVSdprPsBDyugISBrU5","sr":1,"ks":{"a":{"a":0,"k":[6400,6400]},"o":{"a":0,"k":100},"p":{"a":0,"k":[320,98.5]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}},"ao":0,"w":12800,"h":12800,"ip":0,"op":599,"st":0,"bm":0,"refId":"aZDS-kyY0kbcq0zGDZ46J"},{"ddd":0,"ind":9,"ty":4,"nm":"","ln":"63zFQZV_7WxZnASN0o9hU","sr":1,"ks":{"a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[320,98.5]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}},"ao":0,"ip":0,"op":599,"st":0,"bm":0,"shapes":[{"ty":"gr","hd":false,"bm":0,"it":[{"ty":"rc","hd":false,"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[640,197]}},{"ty":"fl","hd":false,"bm":0,"c":{"a":0,"k":[1,1,1]},"r":1,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}],"np":0}]}],"meta":{"g":"https://jitter.video"},"nm":"shift-lab-animated-logo-white-bg","op":599,"v":"5.7.4","w":640}');
;// CONCATENATED MODULE: ./components/Navigation.tsx












function Navigation(param) {
    var _useLightTheme = param.useLightTheme, useLightTheme = _useLightTheme === void 0 ? false : _useLightTheme;
    var ref = (0,react.useState)(false), isNavVisible = ref[0], toggleNavVisibility = ref[1];
    var NavButton = function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            className: "absolute p-2 top-6 right-4 md:right-6 md:w-[48px] lg:hidden w-[42px]",
            onClick: function() {
                return toggleNavVisibility(!isNavVisible);
            },
            children: children
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        role: "banner",
        className: useLightTheme ? "bg-white" : "bg-almostBlack",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* StaticSpacer */.rj, {
                size: "sm"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                className: "col-span-full",
                "aria-label": "Main website navigation",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavButton, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "sr-only",
                                children: "Open mobile navigation"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* IconMobileMenuOpen */.A0, {
                                alt: "Icon - Close mobile menu",
                                color: useLightTheme ? "almostBlack" : "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* GridContainer */.T5, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-full lg:col-span-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-[112px] lg:w-[134px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((index_umd_default()), {
                                                loop: false,
                                                animationData: useLightTheme ? shift_lab_animated_logo_white_bg_namespaceObject : shift_lab_animated_logo_black_bg_namespaceObject
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden col-span-10 lg:flex",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "relative lowercase flex space-x-9 top-[5px]",
                                    children: default_content/* menuItems.map */.pO.map(function(item, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "text-xs md:text-sm place-self-end",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: item.href,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "".concat(useLightTheme ? "text-almostBlack hover:border-almostBlack hover:text-almostBlack" : "text-white hover:border-white hover:text-white", " hover:border-b-2 no-underline"),
                                                    children: item.text
                                                })
                                            })
                                        }, "MenuItem_".concat(i));
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                size: "lg"
            }),
            isNavVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                className: "fixed top-0 z-50 w-screen h-screen bg-white col-span-full",
                "aria-label": "Mobile website navigation",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* StaticSpacer */.rj, {
                        size: "sm"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavButton, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "sr-only",
                                children: "Close mobile navigation"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* IconClose */.bM, {
                                alt: "Icon - Mobile menu open",
                                color: "almostBlack"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* GridContainer */.T5, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-12 col-span-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-[44px] xl:w-[50px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logos/* ShiftLabMark */.A, {
                                                color: useLightTheme ? "almostBlack" : "white"
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    children: default_content/* menuItems.map */.pO.map(function(item, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: item.href,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: "mb-2 font-bold text-left underline lowercase __shift-lab-typography-display-h1 text-almostBlack text-h2Lg",
                                                    onClick: function() {
                                                        return toggleNavVisibility(!isNavVisible);
                                                    },
                                                    children: item.text
                                                })
                                            })
                                        }, "MenuItemMobile_".concat(i));
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                        size: "xl"
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/Layout.tsx






var OG_IMAGE_URL = "https://imgs.shiftlab.co/api/shiftlab-co";
var GTM_ID = "GTM-N6RV5JQ";
var HUBSPOT_ID = "23695656";
var Layout = function(param) {
    var children = param.children, _title = param.title, title = _title === void 0 ? "" : _title, url = param.url, _imageCTA = param.imageCTA, imageCTA = _imageCTA === void 0 ? "" : _imageCTA, _description = param.description, description = _description === void 0 ? "" : _description, _shouldBeIndexed = param.shouldBeIndexed, shouldBeIndexed = _shouldBeIndexed === void 0 ? true : _shouldBeIndexed, _useLightTheme = param.useLightTheme, useLightTheme = _useLightTheme === void 0 ? false : _useLightTheme;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "initial-scale=1, width=device-width"
                    }),
                    !shouldBeIndexed && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "noindex,nofollow"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/x-icon",
                        href: "/favicon.svg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://shiftlab.co".concat(url)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:site",
                        content: "@shiftlabny"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: "".concat(OG_IMAGE_URL, "?cta=").concat(imageCTA, "&w=1200&h=630")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:image",
                        content: "".concat(OG_IMAGE_URL, "?cta=").concat(imageCTA, "&w=1200&h=630")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify({
                                "@context": "https://schema.org",
                                "@type": "LocalBusiness",
                                name: "Shift Lab",
                                image: "".concat(OG_IMAGE_URL, "?cta=Let’s%20talk.&w=1200&h=630"),
                                "@id": "",
                                url: "https://shiftlab.co",
                                telephone: "",
                                address: {
                                    "@type": "PostalAddress",
                                    streetAddress: "290 5th Ave Fl 4",
                                    addressLocality: "New York",
                                    addressRegion: "NY",
                                    postalCode: "10001",
                                    addressCountry: "US"
                                },
                                geo: {
                                    "@type": "GeoCoordinates",
                                    latitude: 40.7463124,
                                    longitude: -73.9864727
                                },
                                sameAs: [
                                    "https://www.facebook.com/shiftlab.co/",
                                    "https://twitter.com/shiftlabny/",
                                    "https://www.linkedin.com/company/shiftlabny/",
                                    "https://www.instagram.com/shiftlab.co/", 
                                ]
                            })
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "google-analytics",
                strategy: "afterInteractive",
                children: "\n        (function(w,d,s,l,i) {\n            w[l]=w[l]||[];\n            w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});\n            var f=d.getElementsByTagName(s)[0], j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:'';\n            j.async=true;\n            j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;\n            f.parentNode.insertBefore(j,f);\n          }\n        )(window, document, 'script', 'dataLayer', '".concat(GTM_ID, "');\n      ")
            }),
            HUBSPOT_ID && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                strategy: "afterInteractive",
                id: "hs-script-loader",
                src: "//js-na1.hs-scripts.com/".concat(HUBSPOT_ID, ".js")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation, {
                useLightTheme: useLightTheme
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                role: "main",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
        ]
    });
};
/* harmony default export */ var components_Layout = (Layout);


/***/ }),

/***/ 7343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ ShiftLabMark; }
/* harmony export */ });
/* unused harmony export ShiftLabLogo */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7479);



var ShiftLabLogo = function(param) {
    var _color = param.color, color = _color === void 0 ? "almostBlack" : _color, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? "" : _customStyles;
    return /*#__PURE__*/ _jsx("div", {
        className: customStyles,
        children: /*#__PURE__*/ _jsxs("svg", {
            width: "100%",
            height: "100%",
            viewBox: "0 0 138 42",
            preserveAspectRatio: "xMinYMid",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ _jsx("title", {
                    children: "Shift Lab - Logo"
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M25.35 28.1886C25.539 30.1676 26.386 31.8896 27.89 33.1256C29.392 34.3616 31.361 34.9806 33.796 34.9806C35.774 34.9806 37.382 34.5716 38.619 33.7526C39.855 32.9356 40.474 31.7846 40.474 30.3006C40.474 29.2346 40.121 28.3976 39.418 27.7896C38.713 27.1806 37.734 26.7046 36.479 26.3626C35.223 26.0206 33.302 25.6016 30.714 25.1066C26.719 24.3466 23.58 23.1286 21.297 21.4536C19.015 19.7806 17.873 17.1166 17.873 13.4646C17.873 11.1436 18.501 9.06062 19.757 7.21462C21.012 5.36962 22.762 3.92362 25.007 2.87662C27.252 1.83162 29.763 1.30762 32.541 1.30762C35.546 1.30762 38.228 1.86962 40.588 2.99062C42.947 4.11362 44.811 5.65462 46.181 7.61462C47.551 9.57462 48.254 11.7716 48.293 14.2056H39.903C39.712 12.4936 38.952 11.0956 37.62 10.0106C36.288 8.92662 34.595 8.38462 32.541 8.38462C30.714 8.38462 29.24 8.76562 28.118 9.52562C26.995 10.2876 26.434 11.3906 26.434 12.8356C26.434 13.8636 26.786 14.6816 27.49 15.2906C28.193 15.8986 29.192 16.3746 30.486 16.7166C31.779 17.0596 33.682 17.4586 36.193 17.9156C38.819 18.4106 41.054 19.0476 42.9 19.8276C44.745 20.6076 46.238 21.7676 47.38 23.3086C48.521 24.8496 49.092 26.8766 49.092 29.3876C49.092 31.7846 48.416 33.9446 47.066 35.8646C45.715 37.7866 43.87 39.2896 41.53 40.3736C39.19 41.4586 36.573 42.0006 33.682 42.0006C30.41 42.0006 27.518 41.4006 25.007 40.2026C22.496 39.0036 20.536 37.3586 19.129 35.2656C17.721 33.1736 16.997 30.8136 16.96 28.1886H25.35Z",
                    fill: getThemeColor(color)
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15.617 33.125C14.114 31.89 13.267 30.167 13.077 28.188H4.68799C4.72499 30.814 5.44799 33.173 6.85599 35.265C8.26299 37.358 10.223 39.004 12.735 40.203C14.04 40.825 15.45 41.282 16.961 41.582V33.998C16.479 33.752 16.029 33.464 15.617 33.125Z",
                    fill: getThemeColor(color)
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15.2176 15.2906C14.5126 14.6816 14.1616 13.8636 14.1616 12.8356C14.1616 11.3906 14.7226 10.2876 15.8446 9.52561C16.1816 9.29761 16.5606 9.11561 16.9606 8.95561V1.59961C15.4646 1.85361 14.0486 2.26561 12.7346 2.87661C10.4886 3.92361 8.73959 5.36961 7.48459 7.21461C6.22859 9.06061 5.60059 11.1436 5.60059 13.4646C5.60059 17.1166 6.74159 19.7806 9.02459 21.4536C11.0176 22.9156 13.6636 24.0286 16.9606 24.7936V16.2956C16.2606 16.0146 15.6716 15.6826 15.2176 15.2906Z",
                    fill: getThemeColor(color)
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M2.168 35.265C2.87 36.309 3.71 37.242 4.688 38.064V28.188H0C0.037 30.814 0.76 33.173 2.168 35.265Z",
                    fill: getThemeColor(color)
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M2.79609 7.21431C1.54009 9.06031 0.913086 11.1433 0.913086 13.4643C0.913086 17.1163 2.05409 19.7803 4.33709 21.4533C4.44909 21.5363 4.57109 21.6133 4.68809 21.6933V5.09131C3.97409 5.73231 3.33009 6.42931 2.79609 7.21431Z",
                    fill: getThemeColor(color)
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M76.6166 15.1559C78.8806 17.2679 80.0126 20.7789 80.0126 25.6879V41.6719H71.9646V26.0879C71.9646 21.2169 69.9846 18.7809 66.0276 18.7809C63.9726 18.7809 62.3646 19.4759 61.2036 20.8639C60.0426 22.2539 59.4626 24.1659 59.4626 26.6019V41.6719H51.4136V1.71289H59.4626V15.4689C60.4906 14.3659 61.6786 13.5099 63.0306 12.9009C64.3806 12.2929 66.0276 11.9879 67.9686 11.9879C71.4696 11.9879 74.3516 13.0439 76.6166 15.1559Z",
                    fill: getThemeColor(color)
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M82.8984 41.672H90.9474V12.33H82.8984V41.672ZM90.2914 1.313C91.1844 2.189 91.6324 3.292 91.6324 4.624C91.6324 5.957 91.1844 7.07 90.2914 7.963C89.3964 8.858 88.2834 9.305 86.9514 9.305C85.6194 9.305 84.4974 8.858 83.5834 7.963C82.6704 7.07 82.2134 5.957 82.2134 4.624C82.2134 3.292 82.6704 2.189 83.5834 1.313C84.4974 0.438 85.6194 0 86.9514 0C88.2834 0 89.3964 0.438 90.2914 1.313Z",
                    fill: getThemeColor(color)
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M98.6323 12.3304V10.0474C98.6323 7.3454 99.3743 5.2804 100.859 3.8534C102.342 2.4264 104.569 1.7124 107.537 1.7124H114.045V8.6764H108.907C108.146 8.6764 107.585 8.8484 107.223 9.1904C106.861 9.5334 106.681 10.0854 106.681 10.8464V12.3304H114.045V19.2384H106.681V41.6724H98.6323V19.2384H93.7803V12.3304H98.6323Z",
                    fill: getThemeColor(color)
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M121.262 19.2382H116.41V12.3302H121.262V4.05322H129.311V12.3302H135.991V19.2382H129.311V32.0822C129.311 33.0342 129.501 33.7092 129.882 34.1082C130.262 34.5082 130.928 34.7072 131.88 34.7072H136.675V41.6722H129.825C126.894 41.6722 124.735 40.9592 123.346 39.5312C121.956 38.1042 121.262 35.9452 121.262 33.0522V19.2382Z",
                    fill: getThemeColor(color)
                })
            ]
        })
    });
};
var ShiftLabMark = function(param) {
    var _color = param.color, color = _color === void 0 ? "almostBlack" : _color, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? "" : _customStyles;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: customStyles,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "100%",
            height: "100%",
            viewBox: "0 0 50 42",
            preserveAspectRatio: "xMinYMid",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: "Shift Lab - Logo Mark"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M25.3509 27.1886C25.5399 29.1676 26.3869 30.8896 27.8909 32.1256C29.3929 33.3616 31.3619 33.9806 33.7969 33.9806C35.7749 33.9806 37.3829 33.5716 38.6199 32.7526C39.8559 31.9356 40.4749 30.7846 40.4749 29.3006C40.4749 28.2346 40.1219 27.3976 39.4189 26.7896C38.7139 26.1806 37.7349 25.7046 36.4799 25.3626C35.2239 25.0206 33.3029 24.6016 30.7149 24.1066C26.7199 23.3466 23.5809 22.1286 21.2979 20.4536C19.0159 18.7806 17.8739 16.1166 17.8739 12.4646C17.8739 10.1436 18.5019 8.06062 19.7579 6.21462C21.0129 4.36962 22.7629 2.92362 25.0079 1.87662C27.2529 0.831617 29.7639 0.307617 32.5419 0.307617C35.5469 0.307617 38.2289 0.869617 40.5889 1.99062C42.9479 3.11362 44.8119 4.65462 46.1819 6.61462C47.5519 8.57462 48.2549 10.7716 48.2939 13.2056H39.9039C39.7129 11.4936 38.9529 10.0956 37.6209 9.01062C36.2889 7.92662 34.5959 7.38462 32.5419 7.38462C30.7149 7.38462 29.2409 7.76562 28.1189 8.52562C26.9959 9.28762 26.4349 10.3906 26.4349 11.8356C26.4349 12.8636 26.7869 13.6816 27.4909 14.2906C28.1939 14.8986 29.1929 15.3746 30.4869 15.7166C31.7799 16.0596 33.6829 16.4586 36.1939 16.9156C38.8199 17.4106 41.0549 18.0476 42.9009 18.8276C44.7459 19.6076 46.2389 20.7676 47.3809 22.3086C48.5219 23.8496 49.0929 25.8766 49.0929 28.3876C49.0929 30.7846 48.4169 32.9446 47.0669 34.8646C45.7159 36.7866 43.8709 38.2896 41.5309 39.3736C39.1909 40.4586 36.5739 41.0006 33.6829 41.0006C30.4109 41.0006 27.5189 40.4006 25.0079 39.2026C22.4969 38.0036 20.5369 36.3586 19.1299 34.2656C17.7219 32.1736 16.9979 29.8136 16.9609 27.1886H25.3509Z",
                    fill: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getThemeColor */ .pe)(color)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15.6165 32.125C14.1135 30.89 13.2665 29.167 13.0765 27.188H4.6875C4.7245 29.814 5.4475 32.173 6.8555 34.265C8.2625 36.358 10.2225 38.004 12.7345 39.203C14.0395 39.825 15.4495 40.282 16.9605 40.582V32.998C16.4785 32.752 16.0285 32.464 15.6165 32.125Z",
                    fill: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getThemeColor */ .pe)(color)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15.2186 14.2906C14.5136 13.6816 14.1626 12.8636 14.1626 11.8356C14.1626 10.3906 14.7236 9.28761 15.8456 8.52561C16.1826 8.29761 16.5616 8.11561 16.9616 7.95561V0.599609C15.4656 0.853609 14.0496 1.26561 12.7356 1.87661C10.4896 2.92361 8.74056 4.36961 7.48556 6.21461C6.22956 8.06061 5.60156 10.1436 5.60156 12.4646C5.60156 16.1166 6.74256 18.7806 9.02556 20.4536C11.0186 21.9156 13.6646 23.0286 16.9616 23.7936V15.2956C16.2616 15.0146 15.6726 14.6826 15.2186 14.2906Z",
                    fill: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getThemeColor */ .pe)(color)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M2.168 34.2655C2.87 35.3095 3.71 36.2425 4.688 37.0645V27.1885H0C0.037 29.8145 0.76 32.1735 2.168 34.2655Z",
                    fill: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getThemeColor */ .pe)(color)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M2.79706 6.2148C1.54106 8.0608 0.914062 10.1438 0.914062 12.4648C0.914062 16.1168 2.05506 18.7808 4.33806 20.4538C4.45006 20.5368 4.57206 20.6138 4.68906 20.6938V4.0918C3.97506 4.7328 3.33106 5.4298 2.79706 6.2148Z",
                    fill: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getThemeColor */ .pe)(color)
                })
            ]
        })
    });
};


/***/ }),

/***/ 6435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Yj": function() { return /* binding */ ResponsiveSpacer; },
/* harmony export */   "rj": function() { return /* binding */ StaticSpacer; }
/* harmony export */ });
/* unused harmony export ArbitrarySpacer */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* provided dependency */ var process = __webpack_require__(4155);

var appDebugMode = process.env.DEBUG_DESIGN_SPACING === "true";
var ResponsiveSpacer = function(param) {
    var size = param.size, _debugMode = param.debugMode, debugMode = _debugMode === void 0 ? false : _debugMode;
    var spacingClass = "";
    var debugStyles = (appDebugMode || debugMode) && "bg-debugSpacing";
    switch(size){
        case "xs":
            spacingClass = "__shift-lab-spacing-responsive-xs";
            break;
        case "sm":
            spacingClass = "__shift-lab-spacing-responsive-sm";
            break;
        case "md":
            spacingClass = "__shift-lab-spacing-responsive-md";
            break;
        case "lg":
            spacingClass = "__shift-lab-spacing-responsive-lg";
            break;
        case "xl":
            spacingClass = "__shift-lab-spacing-responsive-xl";
            break;
        case "2xl":
            spacingClass = "__shift-lab-spacing-responsive-2xl";
            break;
        case "3xl":
            spacingClass = "__shift-lab-spacing-responsive-3xl";
            break;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(spacingClass, " ").concat(debugStyles)
    });
};
var StaticSpacer = function(param) {
    var size = param.size, _debugMode = param.debugMode, debugMode = _debugMode === void 0 ? false : _debugMode;
    var spacingClass = "";
    var debugStyles = (appDebugMode || debugMode) && "bg-debugSpacing";
    switch(size){
        case "xs":
            spacingClass = "__shift-lab-spacing-static-xs";
            break;
        case "sm":
            spacingClass = "__shift-lab-spacing-static-sm";
            break;
        case "md":
            spacingClass = "__shift-lab-spacing-static-md";
            break;
        case "lg":
            spacingClass = "__shift-lab-spacing-static-lg";
            break;
        case "xl":
            spacingClass = "__shift-lab-spacing-static-xl";
            break;
        case "2xl":
            spacingClass = "__shift-lab-spacing-static-2xl";
            break;
        case "3xl":
            spacingClass = "__shift-lab-spacing-static-3xl";
            break;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(spacingClass, " ").concat(debugStyles)
    });
};
var ArbitrarySpacer = function(param) {
    var classes = param.classes, _debugMode = param.debugMode, debugMode = _debugMode === void 0 ? false : _debugMode;
    var debugStyles = (appDebugMode || debugMode) && "bg-debugSpacing";
    return /*#__PURE__*/ _jsx("div", {
        className: "".concat(classes, " ").concat(debugStyles)
    });
};


/***/ }),

/***/ 7734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ac": function() { return /* binding */ BodyText; },
/* harmony export */   "V": function() { return /* binding */ H1Display; },
/* harmony export */   "Zm": function() { return /* binding */ H2Display; },
/* harmony export */   "f7": function() { return /* binding */ SuperDisplay; },
/* harmony export */   "k$": function() { return /* binding */ BaseText; },
/* harmony export */   "rd": function() { return /* binding */ H4Display; },
/* harmony export */   "tL": function() { return /* binding */ H3Display; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


var SuperDisplay = function(param) {
    var children = param.children, _bold = param.bold, bold = _bold === void 0 ? false : _bold, _italic = param.italic, italic = _italic === void 0 ? false : _italic;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "lg:-ml-4 __shift-lab-typography-display-super ".concat(bold ? "font-bold" : "font-normal", " ").concat(italic ? "italic" : "not-italic"),
        children: children
    });
};
var H1Display = function(param) {
    var children = param.children, _bold = param.bold, bold = _bold === void 0 ? false : _bold, _italic = param.italic, italic = _italic === void 0 ? false : _italic;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "md:-ml-2 __shift-lab-typography-display-h1 ".concat(bold ? "font-bold" : "font-normal", " ").concat(italic ? "italic" : "not-italic"),
        children: children
    });
};
var H2Display = function(param) {
    var children = param.children, _bold = param.bold, bold = _bold === void 0 ? false : _bold, _italic = param.italic, italic = _italic === void 0 ? false : _italic;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "__shift-lab-typography-display-h2 ".concat(bold ? "font-bold" : "font-normal", " ").concat(italic ? "italic" : "not-italic"),
        children: children
    });
};
var H3Display = function(param) {
    var children = param.children, _bold = param.bold, bold = _bold === void 0 ? false : _bold, _italic = param.italic, italic = _italic === void 0 ? false : _italic;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "__shift-lab-typography-display-h3 ".concat(bold ? "font-bold" : "font-normal", " ").concat(italic ? "italic" : "not-italic"),
        children: children
    });
};
var H4Display = function(param) {
    var children = param.children, _bold = param.bold, bold = _bold === void 0 ? false : _bold, _italic = param.italic, italic = _italic === void 0 ? false : _italic;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "__shift-lab-typography-display-h4 ".concat(bold ? "font-bold" : "font-normal", " ").concat(italic ? "italic" : "not-italic"),
        children: children
    });
};
var BodyText = function(param) {
    var children = param.children, _bold = param.bold, bold = _bold === void 0 ? false : _bold, _italic = param.italic, italic = _italic === void 0 ? false : _italic;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "__shift-lab-typography-text-body ".concat(bold ? "font-bold" : "font-normal", " ").concat(italic ? "italic" : "not-italic"),
        children: children
    });
};
var BaseText = function(param) {
    var children = param.children, _bold = param.bold, bold = _bold === void 0 ? false : _bold, _italic = param.italic, italic = _italic === void 0 ? false : _italic;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "__shift-lab-typography-text-base ".concat(bold ? "font-bold" : "", " ").concat(italic ? "italic" : "not-italic"),
        children: children
    });
};


/***/ }),

/***/ 7981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ ContentfulRichTextContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4129);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6437);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7479);






function renderOptions(links) {
    //
    //
    // Read more about this approach here:
    // https://www.contentful.com/blog/2021/04/14/rendering-linked-assets-entries-in-contentful/
    //
    //
    var assetMap = new Map();
    if (links) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = links.assets.block[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var asset = _step.value;
                assetMap.set(asset.sys.id, asset);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    var _obj;
    return {
        renderNode: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.INLINES.HYPERLINK, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: node.data.uri,
                target: "_blank",
                rel: "noreferrer",
                children: node.content[0].value
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.EMBEDDED_ASSET, function(node) {
            var asset = assetMap.get(node.data.target.sys.id);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "embedded-asset",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                    loader: function() {
                        return (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_4__/* .contentfulImageLoader */ ._u)({
                            src: asset.url,
                            width: asset.width,
                            quality: 90,
                            fit: "thumb"
                        });
                    },
                    src: asset.url,
                    alt: asset.title,
                    layout: "responsive",
                    width: asset.width,
                    height: asset.height
                })
            });
        }), _obj)
    };
}
function ContentfulRichTextContent(param) {
    var richText = param.richText;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_1__/* .documentToReactComponents */ .h)(richText.json, renderOptions(richText.links))
    });
}


/***/ }),

/***/ 1612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ MapPageContent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/use-scroll.mjs + 12 modules
var use_scroll = __webpack_require__(8263);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/use-transform.mjs + 4 modules
var use_transform = __webpack_require__(56);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 169 modules
var motion = __webpack_require__(4247);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/Grid.tsx
var Grid = __webpack_require__(7504);
// EXTERNAL MODULE: ./components/Icons.tsx
var Icons = __webpack_require__(436);
// EXTERNAL MODULE: ./components/Spacing.tsx
var Spacing = __webpack_require__(6435);
// EXTERNAL MODULE: ./components/Typography.tsx
var Typography = __webpack_require__(7734);
// EXTERNAL MODULE: ./utils/helpers.tsx
var helpers = __webpack_require__(7479);
;// CONCATENATED MODULE: ./components/cms/ComponentBlogRoll.tsx









var ComponentBlogRoll = function(param) {
    var postsCollection = param.postsCollection;
    var target = (0,react.useRef)(null);
    var scrollYProgress = (0,use_scroll/* useScroll */.v)({
        target: target,
        offset: [
            "start end",
            "end center"
        ]
    }).scrollYProgress;
    var parallax = (0,use_transform/* useTransform */.H)(scrollYProgress, [
        0,
        1
    ], [
        -300,
        100
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "relative z-0 bg-white text-almostBlack",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                size: "md"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridContainer */.T5, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* BaseText */.k$, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "lowercase",
                            children: "Expertise + thinking"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                size: "xs"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridContainer */.T5, {
                children: postsCollection.items.map(function(item, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pr-4 col-span-full lg:col-span-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* H2Display */.Zm, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.span */.E.span, {
                                        initial: "hide",
                                        whileInView: "show",
                                        variants: (0,helpers/* animationFadeInOut */.om)(),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/thinking/".concat(item.slug),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "underline hover:text-yellow",
                                                children: item.pageTitle
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                size: "md"
                            })
                        ]
                    }, "BlogPost_".concat(i));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                size: "xs"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridContainer */.T5, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-w-[48%] min-w-[46px] lg:min-w-[56px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                        initial: "hide",
                        whileInView: "show",
                        variants: (0,helpers/* animationRotate */.aK)(),
                        style: {
                            y: (0,use_transform/* useTransform */.H)(parallax, function(v) {
                                return -v * 2;
                            })
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* IconX */.kL, {
                            color: "almostBlack",
                            alt: ""
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                size: "lg"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/lottie-react/build/index.umd.js
var index_umd = __webpack_require__(9260);
// EXTERNAL MODULE: ./components/Buttons.tsx
var Buttons = __webpack_require__(3739);
// EXTERNAL MODULE: ./components/cms/__ContentfulRichTextContent.tsx
var _ContentfulRichTextContent = __webpack_require__(7981);
;// CONCATENATED MODULE: ./components/cms/ComponentCallToAction.tsx











var ComponentCallToAction = function(ctaContent) {
    var style = {
        border: 0
    };
    var options = {
        animationData: ctaContent.animationJson
    };
    var ContactAnimation = function() {
        var lottieObj = (0,index_umd.useLottie)(options, style);
        var Animation = (0,index_umd.useLottieInteractivity)({
            lottieObj: lottieObj,
            mode: "scroll",
            actions: [
                {
                    visibility: [
                        0.01,
                        0.9
                    ],
                    type: "play",
                    frames: [
                        0,
                        420
                    ]
                }, 
            ]
        });
        return Animation;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "relative z-1",
        id: "contact-cta",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* GridContainer */.T5, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-span-full lg:col-span-6 bg-almostBlack",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                            size: "md"
                        }),
                        ctaContent.subheading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* BaseText */.k$, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(helpers/* HTMLWrapper */.oK, {
                                    wrapperElement: ctaContent.subheadingHtmlElement,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "lowercase text-yellow",
                                        dangerouslySetInnerHTML: {
                                            __html: ctaContent.subheading
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                    size: "xs"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                            initial: "hide",
                            whileInView: "show",
                            variants: (0,helpers/* animationFadeInOut */.om)(),
                            children: ctaContent.headline && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* H2Display */.Zm, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(helpers/* HTMLWrapper */.oK, {
                                    wrapperElement: ctaContent.headlineHtmlElement,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        dangerouslySetInnerHTML: {
                                            __html: ctaContent.headline
                                        }
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                            size: "sm"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                            initial: "hide",
                            whileInView: "show",
                            variants: (0,helpers/* animationFlyInOut */.$c)({
                                direction: "flyInFromLeft"
                            }),
                            children: [
                                ctaContent.textBlock && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-span-full xl:col-span-4 xl:max-w-[640px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* BodyText */.Ac, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                                size: "sm"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(_ContentfulRichTextContent/* ContentfulRichTextContent */.L, {
                                                richText: ctaContent.textBlock
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                    size: "md"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* Button */.z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: ctaContent.buttonUrl,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "__shift-lab-button-link",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: ctaContent.buttonText
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                            size: "lg"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-full lg:col-span-7 lg:col-start-7",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                        initial: "hide",
                        whileInView: "show",
                        variants: (0,helpers/* animationFadeInOut */.om)(),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactAnimation, {})
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/cms/ContentCaseStudies.tsx









var ContentCaseStudies = function(param) {
    var displayTitle = param.displayTitle, image = param.image, textBlock = param.textBlock, animationJson = param.animationJson;
    var LottieAnimation = function() {
        var lottieObj = (0,index_umd.useLottie)({
            animationData: animationJson
        });
        var Animation = (0,index_umd.useLottieInteractivity)({
            lottieObj: lottieObj,
            mode: "scroll",
            actions: [
                {
                    visibility: [
                        0.2,
                        0.75
                    ],
                    type: "seek",
                    frames: [
                        1,
                        119
                    ]
                }, 
            ]
        });
        return Animation;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                initial: "hide",
                whileInView: "show",
                variants: (0,helpers/* animationFadeInOut */.om)(),
                children: animationJson ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LottieAnimation, {})
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-w-[83%]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        loader: function() {
                            return (0,helpers/* contentfulImageLoader */._u)({
                                src: image.url,
                                width: image.width,
                                quality: 94,
                                fit: "scale"
                            });
                        },
                        alt: "Image showing a product designed or developed by Shift Lab for ".concat(displayTitle),
                        src: image.url,
                        layout: "responsive",
                        height: image.height,
                        width: image.width
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                size: "md"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* H2Display */.Zm, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.span */.E.span, {
                        initial: "hide",
                        whileInView: "show",
                        variants: (0,helpers/* animationFadeInOut */.om)(),
                        children: displayTitle
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                size: "xs"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* BodyText */.Ac, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-w-[720px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.span */.E.span, {
                        initial: "hide",
                        whileInView: "show",
                        variants: (0,helpers/* animationFadeInOut */.om)(),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "__shift-lab-rich-text-block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(_ContentfulRichTextContent/* ContentfulRichTextContent */.L, {
                                richText: textBlock
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                size: "md"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/cms/ComponentCaseStudyGroup.tsx











var ComponentCaseStudyGroup = function(param) {
    var _subheading = param.subheading, subheading = _subheading === void 0 ? "" : _subheading, _subheadingHtmlElement = param.subheadingHtmlElement, subheadingHtmlElement = _subheadingHtmlElement === void 0 ? "p" : _subheadingHtmlElement, _showSeeAllWorkCta = param.showSeeAllWorkCta, showSeeAllWorkCta = _showSeeAllWorkCta === void 0 ? false : _showSeeAllWorkCta, caseStudiesCollection = param.caseStudiesCollection;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative z-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                size: "md"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridContainer */.T5, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-full lg:col-span-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* BaseText */.k$, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(helpers/* HTMLWrapper */.oK, {
                            wrapperElement: subheadingHtmlElement,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "lowercase text-yellow",
                                dangerouslySetInnerHTML: {
                                    __html: subheading
                                }
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                size: "sm"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridContainer */.T5, {
                children: caseStudiesCollection.items.map(function(item, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "__shift-lab-case-study",
                        children: [
                            i % 2 == 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                size: "2xl"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCaseStudies, (0,_object_spread/* default */.Z)({}, item))
                        ]
                    }, "ShiftLabCaseStudy_".concat(i));
                })
            }),
            showSeeAllWorkCta && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridContainer */.T5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-span-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                initial: "hide",
                                whileInView: "show",
                                variants: (0,helpers/* animationFlyInOut */.$c)({
                                    direction: "flyInFromLeft"
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* Button */.z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/work",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "__shift-lab-button-link",
                                            children: "See all work"
                                        })
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                        size: "lg"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next-hubspot/lib/index.esm.js
var index_esm = __webpack_require__(6849);
// EXTERNAL MODULE: ./content/default-content.ts
var default_content = __webpack_require__(4132);
;// CONCATENATED MODULE: ./components/cms/ComponentForms.tsx













var HUBSPOT_ID = "23695656";
var HubspotForm = function(id) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var ref = (0,index_esm/* useHubspotForm */.k1)({
        portalId: "".concat(HUBSPOT_ID),
        formId: "".concat(id),
        target: "#hubspot-general-contact-form-wrapper__key__".concat(id)
    }), loaded = ref.loaded, error = ref.error, formCreated = ref.formCreated;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "__shift-lab-embedded-form hubspot-webform",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: "hubspot-general-contact-form-wrapper__key__".concat(id)
        })
    });
};
var ComponentForms = function(param) {
    var _subheading = param.subheading, subheading = _subheading === void 0 ? "" : _subheading, subheadingHtmlElement = param.subheadingHtmlElement, _headline = param.headline, headline = _headline === void 0 ? "" : _headline, headlineHtmlElement = param.headlineHtmlElement, textBlock = param.textBlock, hubspotFormId = param.hubspotFormId, _showContactInformation = param.showContactInformation, showContactInformation = _showContactInformation === void 0 ? false : _showContactInformation, blogRoll = param.blogRoll;
    var target = (0,react.useRef)(null);
    var scrollYProgress = (0,use_scroll/* useScroll */.v)({
        target: target,
        offset: [
            "start end",
            "end center"
        ]
    }).scrollYProgress;
    var parallax = (0,use_transform/* useTransform */.H)(scrollYProgress, [
        0,
        1
    ], [
        -200,
        100
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative z-1 hubspot-webform bg-almostBlack",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* GridContainer */.T5, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-full lg:col-span-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                size: "md"
                            }),
                            subheading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* BaseText */.k$, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(helpers/* HTMLWrapper */.oK, {
                                        wrapperElement: subheadingHtmlElement,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "lowercase text-yellow",
                                            dangerouslySetInnerHTML: {
                                                __html: subheading
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                        size: "xs"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                initial: "hide",
                                whileInView: "show",
                                variants: (0,helpers/* animationFadeInOut */.om)(),
                                children: headline && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* H2Display */.Zm, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(helpers/* HTMLWrapper */.oK, {
                                        wrapperElement: headlineHtmlElement,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            dangerouslySetInnerHTML: {
                                                __html: headline
                                            }
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                initial: "hide",
                                whileInView: "show",
                                variants: (0,helpers/* animationFadeInOut */.om)(),
                                children: textBlock && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "xl:max-w-[640px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* BodyText */.Ac, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                                size: "sm"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(_ContentfulRichTextContent/* ContentfulRichTextContent */.L, {
                                                richText: textBlock
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                size: "sm"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.span */.E.span, {
                                initial: "hide",
                                whileInView: "show",
                                variants: (0,helpers/* animationFadeInOut */.om)(),
                                children: HubspotForm(hubspotFormId)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                size: "lg"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-span-full lg:col-span-5 lg:col-start-8 2xl:col-span-4 2xl:col-start-8",
                    children: [
                        showContactInformation && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                    size: "md"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "__shift-lab-typography-text-inline-link",
                                    target: "_blank",
                                    href: "https://goo.gl/maps/4hDwNe9a3nA3TQhd9",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        loader: function() {
                                            return (0,helpers/* imgixLoader */.Xi)({
                                                src: "shift-lab-nyc-map.jpg",
                                                width: 966,
                                                quality: 95,
                                                format: "webp"
                                            });
                                        },
                                        alt: "Map of NYC showing Shift Lab office location",
                                        src: "shift-lab-nyc-map.jpg",
                                        layout: "responsive",
                                        height: 453,
                                        width: 966
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                    size: "sm"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* H4Display */.rd, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                className: "__shift-lab-typography-text-inline-link",
                                                target: "_blank",
                                                href: "https://goo.gl/maps/4hDwNe9a3nA3TQhd9",
                                                rel: "noreferrer",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "290 5th Ave Fl 4"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "New York, NY 10001"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Between 30th & 31st"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                    size: "md"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* H4Display */.rd, {
                                    children: default_content/* contactItems.reverse */.Wf.reverse().map(function(item, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-yellow",
                                                    children: item.label
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        dangerouslySetInnerHTML: {
                                                            __html: item.text
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                                    size: "md"
                                                })
                                            ]
                                        }, "ContactItem_".concat(i));
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                    size: "lg"
                                })
                            ]
                        }),
                        blogRoll && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                    size: "md"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridContainer */.T5, {
                                    noMargin: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-span-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* BaseText */.k$, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "lowercase text-yellow",
                                                children: "Expertise + thinking"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                    size: "sm"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridContainer */.T5, {
                                    noMargin: true,
                                    children: blogRoll.postsCollection.items.map(function(item, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-span-full",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* H2Display */.Zm, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.span */.E.span, {
                                                            initial: "hide",
                                                            whileInView: "show",
                                                            variants: (0,helpers/* animationFadeInOut */.om)(),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/thinking/".concat(item.slug),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    className: "underline block hover:text-yellow bg-white text-almostBlack p-[.75rem] pt-[1rem] pb-[1.25rem] hover:bg-black",
                                                                    children: item.pageTitle
                                                                })
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                                    size: "md"
                                                })
                                            ]
                                        }, "BlogPost_".concat(i));
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridContainer */.T5, {
                            noMargin: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "max-w-[48%] min-w-[46px] lg:min-w-[56px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                    initial: "hide",
                                    whileInView: "show",
                                    variants: (0,helpers/* animationRotate */.aK)(),
                                    style: {
                                        y: (0,use_transform/* useTransform */.H)(parallax, function(v) {
                                            return -v * 2;
                                        })
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* IconX */.kL, {
                                        color: "white",
                                        alt: ""
                                    })
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/cms/ComponentIcons.tsx




var ComponentIcons = function(param) {
    var iconType = param.iconType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: iconType === "icon-cursor__animated" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridContainer */.T5, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "-ml-2 col-span-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* IconCursor */.BX, {
                    alt: "",
                    animated: true,
                    color: "white",
                    customStyles: "p-2 w-[56px] md:w-[76px] lg:w-[112px]"
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/cms/ComponentImageWall.tsx










var getMaxWidth = function(contentMaxWidth) {
    switch(contentMaxWidth){
        case "860px":
            return "max-w-[860px]";
            break;
        case "960px":
            return "max-w-[960px]";
            break;
        case "1060px":
            return "max-w-[1060px]";
            break;
        case "1160px":
            return "max-w-[1160px]";
            break;
        case "1260px":
            return "max-w-[1260px]";
            break;
        case "1360px":
            return "max-w-[1360px]";
            break;
        case "1460px":
            return "max-w-[1460px]";
            break;
    }
};
var ComponentImageWall = function(param) {
    var _subheading = param.subheading, subheading = _subheading === void 0 ? "" : _subheading, _subheadingHtmlElement = param.subheadingHtmlElement, subheadingHtmlElement = _subheadingHtmlElement === void 0 ? "p" : _subheadingHtmlElement, _headline = param.headline, headline = _headline === void 0 ? "" : _headline, _headlineHtmlElement = param.headlineHtmlElement, headlineHtmlElement = _headlineHtmlElement === void 0 ? "p" : _headlineHtmlElement, textBlock = param.textBlock, imagesCollection = param.imagesCollection, contentMaxWidth = param.contentMaxWidth;
    var target = (0,react.useRef)(null);
    var scrollYProgress = (0,use_scroll/* useScroll */.v)({
        target: target,
        offset: [
            "start end",
            "end center"
        ]
    }).scrollYProgress;
    var parallax = (0,use_transform/* useTransform */.H)(scrollYProgress, [
        0,
        1
    ], [
        -16,
        32
    ]);
    var parallaxIcon = (0,use_transform/* useTransform */.H)(scrollYProgress, [
        0,
        1
    ], [
        -500,
        100
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "relative bg-white text-almostBlack z-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridContainer */.T5, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-span-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                            size: "md"
                        }),
                        subheading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* BaseText */.k$, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(helpers/* HTMLWrapper */.oK, {
                                    wrapperElement: subheadingHtmlElement,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "lowercase",
                                        dangerouslySetInnerHTML: {
                                            __html: subheading
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                    size: "xs"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                            className: "".concat(getMaxWidth(contentMaxWidth)),
                            initial: "hide",
                            whileInView: "show",
                            variants: (0,helpers/* animationFadeInOut */.om)(),
                            children: headline && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* H2Display */.Zm, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(helpers/* HTMLWrapper */.oK, {
                                    wrapperElement: headlineHtmlElement,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        dangerouslySetInnerHTML: {
                                            __html: headline
                                        }
                                    })
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                initial: "hide",
                whileInView: "show",
                variants: (0,helpers/* animationFadeInOut */.om)(),
                style: {
                    y: (0,use_transform/* useTransform */.H)(parallax, function(v) {
                        return v * 2;
                    })
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridContainer */.T5, {
                    children: textBlock && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-span-full xl:col-span-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* BodyText */.Ac, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                        size: "sm"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(_ContentfulRichTextContent/* ContentfulRichTextContent */.L, {
                                        richText: textBlock
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                size: "md"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                initial: "hide",
                whileInView: "show",
                exit: "hide",
                variants: (0,helpers/* animationFadeInOut */.om)(),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridContainer */.T5, {
                        customStyles: "absolute",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "max-w-[48%] min-w-[46px] lg:min-w-[56px] hidden lg:block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                initial: "hide",
                                whileInView: "show",
                                variants: (0,helpers/* animationRotate */.aK)(),
                                style: {
                                    y: (0,use_transform/* useTransform */.H)(parallaxIcon, function(v) {
                                        return -v * 2;
                                    })
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* IconX */.kL, {
                                    color: "almostBlack",
                                    alt: ""
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridContainer */.T5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-span-full lg:col-span-13 xl:col-span-121",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-wrap items-center justify-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "min-w-[4.5%] flex-initial hidden lg:block"
                                    }),
                                    imagesCollection.items.map(function(item, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "min-w-[25%] lg:min-w-[16%] flex-initial",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                loader: function() {
                                                    return (0,helpers/* contentfulImageLoader */._u)({
                                                        src: item.url,
                                                        width: item.width,
                                                        quality: 94,
                                                        fit: "scale"
                                                    });
                                                },
                                                alt: "Image showing a product designed or developed by Shift Lab for ...",
                                                src: item.url,
                                                layout: "responsive",
                                                height: item.height,
                                                width: item.width
                                            })
                                        }, "ShiftLabImageWallItem_".concat(i));
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                size: "xl"
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/Logos.tsx
var Logos = __webpack_require__(7343);
;// CONCATENATED MODULE: ./components/cms/ComponentIntroBlock.tsx












var ComponentIntroBlock_getMaxWidth = function(contentMaxWidth) {
    switch(contentMaxWidth){
        case "560px":
            return "max-w-[860px]";
            break;
        case "660px":
            return "max-w-[860px]";
            break;
        case "760px":
            return "max-w-[860px]";
            break;
        case "860px":
            return "max-w-[860px]";
            break;
        case "960px":
            return "max-w-[960px]";
            break;
        case "1060px":
            return "max-w-[1060px]";
            break;
    }
};
var ComponentIntroBlock = function(param) {
    var _subheading = param.subheading, subheading = _subheading === void 0 ? "" : _subheading, subheadingHtmlElement = param.subheadingHtmlElement, _headline = param.headline, headline = _headline === void 0 ? "" : _headline, headlineHtmlElement = param.headlineHtmlElement, textBlock = param.textBlock, contentMaxWidth = param.contentMaxWidth, ctaButtonText = param.ctaButtonText, _ctaButtonUrl = param.ctaButtonUrl, ctaButtonUrl = _ctaButtonUrl === void 0 ? "" : _ctaButtonUrl, showLogoParallax = param.showLogoParallax, parallaxImageLeft = param.parallaxImageLeft, parallaxImageRight = param.parallaxImageRight;
    var target = (0,react.useRef)(null);
    var scrollYProgress = (0,use_scroll/* useScroll */.v)({
        target: target,
        offset: [
            "start end",
            "end start"
        ]
    }).scrollYProgress;
    var parallax = (0,use_transform/* useTransform */.H)(scrollYProgress, [
        0,
        1
    ], [
        -100,
        400
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "relative z-1",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* GridContainer */.T5, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                    className: "h-[460px] lg:h-auto col-span-full lg:col-span-6",
                    style: {
                        y: (0,use_transform/* useTransform */.H)(parallax, function(v) {
                            return -v * 4;
                        })
                    },
                    children: [
                        subheading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* BaseText */.k$, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(helpers/* HTMLWrapper */.oK, {
                                    wrapperElement: subheadingHtmlElement,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "lowercase text-yellow",
                                        dangerouslySetInnerHTML: {
                                            __html: subheading
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                    size: "xs"
                                })
                            ]
                        }),
                        headline && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* H2Display */.Zm, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat(ComponentIntroBlock_getMaxWidth(contentMaxWidth)),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(helpers/* HTMLWrapper */.oK, {
                                        wrapperElement: headlineHtmlElement,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            dangerouslySetInnerHTML: {
                                                __html: headline
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                        size: "xs"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                            className: "max-w-[660px]",
                            initial: "hide",
                            whileInView: "show",
                            variants: (0,helpers/* animationFadeInOut */.om)(),
                            children: textBlock && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-full xl:col-span-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* BodyText */.Ac, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                            size: "sm"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(_ContentfulRichTextContent/* ContentfulRichTextContent */.L, {
                                            richText: textBlock
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                            size: "md"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                            initial: "hide",
                            whileInView: "show",
                            variants: (0,helpers/* animationFlyInOut */.$c)({
                                direction: "flyInFromLeft"
                            }),
                            children: ctaButtonText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* Button */.z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: ctaButtonUrl,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "__shift-lab-button-link",
                                        children: ctaButtonText
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                    className: "hidden col-span-1 col-start-8 lg:block",
                    initial: "hide",
                    whileInView: "show",
                    variants: (0,helpers/* animationFadeInOut */.om)(),
                    style: {
                        y: (0,use_transform/* useTransform */.H)(parallax, function(v) {
                            return -v * 4;
                        })
                    },
                    children: parallaxImageLeft && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        loader: function() {
                            return (0,helpers/* contentfulImageLoader */._u)({
                                src: parallaxImageLeft.url,
                                width: parallaxImageLeft.width,
                                quality: 94,
                                fit: "scale"
                            });
                        },
                        alt: "=",
                        src: parallaxImageLeft.url,
                        layout: "responsive",
                        height: parallaxImageLeft.height,
                        width: parallaxImageLeft.width
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                    className: "relative hidden col-span-1 overflow-hidden lg:block",
                    initial: "hide",
                    whileInView: "show",
                    variants: (0,helpers/* animationFlyInOut */.$c)({
                        direction: "flyInFromRight"
                    }),
                    style: {
                        y: (0,use_transform/* useTransform */.H)(parallax, function(v) {
                            return v * 2;
                        })
                    },
                    children: showLogoParallax && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-[200px] xl:w-[260px] absolute bottom-[15%] xl:-right-[175px] -right-[135px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logos/* ShiftLabMark */.A, {
                            color: "yellow"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hidden col-span-3 col-start-10 lg:block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                        initial: "hide",
                        whileInView: "show",
                        variants: (0,helpers/* animationFadeInOut */.om)(),
                        style: {
                            y: (0,use_transform/* useTransform */.H)(parallax, function(v) {
                                return v * 4;
                            })
                        },
                        children: parallaxImageRight && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            loader: function() {
                                return (0,helpers/* contentfulImageLoader */._u)({
                                    src: parallaxImageRight.url,
                                    width: parallaxImageRight.width,
                                    quality: 94,
                                    fit: "scale"
                                });
                            },
                            alt: "=",
                            src: parallaxImageRight.url,
                            layout: "responsive",
                            height: parallaxImageRight.height,
                            width: parallaxImageRight.width
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/SummaryCard.tsx





var SummaryCard = function(param) {
    var title = param.title, ctaText = param.ctaText, linkUrl = param.linkUrl, summary = param.summary;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridContainer */.T5, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "col-span-full max-w-[800px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* H2Display */.Zm, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* StaticSpacer */.rj, {
                            size: "xs"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* BodyText */.Ac, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: summary
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                            size: "sm"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: linkUrl,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "__shift-lab-typography-text-inline-link",
                                children: ctaText
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/cms/ComponentOpenRolesGroup.tsx










var ComponentOpenRolesGroup = function(param) {
    var _subheading = param.subheading, subheading = _subheading === void 0 ? "" : _subheading, _subheadingHtmlElement = param.subheadingHtmlElement, subheadingHtmlElement = _subheadingHtmlElement === void 0 ? "p" : _subheadingHtmlElement, openRolesCollection = param.openRolesCollection, _showSeeAllOpenRolesCta = param.showSeeAllOpenRolesCta, showSeeAllOpenRolesCta = _showSeeAllOpenRolesCta === void 0 ? true : _showSeeAllOpenRolesCta;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "relative bg-white border text-almostBlack z-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                size: "md"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridContainer */.T5, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-full lg:col-span-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* BaseText */.k$, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(helpers/* HTMLWrapper */.oK, {
                            wrapperElement: subheadingHtmlElement,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "lowercase text-almostBlack",
                                dangerouslySetInnerHTML: {
                                    __html: subheading
                                }
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                size: "sm"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridContainer */.T5, {
                noMargin: true,
                children: openRolesCollection.items.map(function(item, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "__shift-lab-case-study",
                        children: [
                            i % 2 == 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                size: "xl"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.span */.E.span, {
                                initial: "hide",
                                whileInView: "show",
                                variants: (0,helpers/* animationFadeInOut */.om)(),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryCard, {
                                    title: item.displayTitle,
                                    ctaText: item.ctaSummaryLink,
                                    linkUrl: "/careers/".concat(item.slug),
                                    summary: item.jobSummary
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                size: "lg"
                            })
                        ]
                    }, "ShiftLabCaseStudy_".concat(i));
                })
            }),
            showSeeAllOpenRolesCta && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                        size: "lg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridContainer */.T5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-span-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                initial: "hide",
                                whileInView: "show",
                                variants: (0,helpers/* animationFlyInOut */.$c)({
                                    direction: "flyInFromLeft"
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* Button */.z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/careers",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "__shift-lab-button-link",
                                            children: "See all open roles"
                                        })
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                        size: "md"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/cms/ComponentSpacers.tsx



var ComponentSpacers = function(param) {
    var size = param.size, responsiveOrStatic = param.responsiveOrStatic;
    return responsiveOrStatic === "responsive" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
        size: size
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* StaticSpacer */.rj, {
        size: size
    });
};

;// CONCATENATED MODULE: ./components/cms/ContentHeroTagline.tsx





var ContentHeroTagline_getMaxWidth = function(contentMaxWidth) {
    switch(contentMaxWidth){
        case "1060px":
            return "max-w-[1060px]";
            break;
        case "1160px":
            return "max-w-[1160px]";
            break;
        case "1260px":
            return "max-w-[1260px]";
            break;
        case "1360px":
            return "max-w-[1360px]";
            break;
        case "1460px":
            return "max-w-[1460px]";
            break;
        case "1560px":
            return "max-w-[1560px]";
            break;
        case "1660px":
            return "max-w-[1660px]";
            break;
    }
};
var ContentHeroTagline = function(param) {
    var taglineHtmlElement = param.taglineHtmlElement, taglineCopy = param.taglineCopy, contentMaxWidth = param.contentMaxWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridContainer */.T5, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridRowGroupOne */.Q9, {
                customStyles: "".concat(ContentHeroTagline_getMaxWidth(contentMaxWidth)),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* H1Display */.V, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(helpers/* HTMLWrapper */.oK, {
                        wrapperElement: taglineHtmlElement,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: taglineCopy
                            }
                        })
                    })
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/cms/ContentRichTextArea.tsx







var ContentRichTextArea_getMaxWidth = function(contentMaxWidth) {
    switch(contentMaxWidth){
        case "660px":
            return "max-w-[660px]";
            break;
        case "760px":
            return "max-w-[760px]";
            break;
        case "860px":
            return "max-w-[860px]";
            break;
        case "960px":
            return "max-w-[960px]";
            break;
        case "1060px":
            return "max-w-[1060px]";
            break;
        case "1160px":
            return "max-w-[1160px]";
            break;
    }
};
var ContentRichTextArea = function(param) {
    var _headline = param.headline, headline = _headline === void 0 ? "" : _headline, headlineHtmlElement = param.headlineHtmlElement, textBlock = param.textBlock, contentMaxWidth = param.contentMaxWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* GridContainer */.T5, {
            children: [
                headline && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "font-bold col-span-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* H3Display */.tL, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(helpers/* HTMLWrapper */.oK, {
                                wrapperElement: headlineHtmlElement,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-bold",
                                    dangerouslySetInnerHTML: {
                                        __html: headline
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                            className: "mt-2 w-[64px] h-[6px] bg-yellow border-0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                            size: "sm"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-full ".concat(ContentRichTextArea_getMaxWidth(contentMaxWidth)),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* BodyText */.Ac, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "__shift-lab-rich-text-block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(_ContentfulRichTextContent/* ContentfulRichTextContent */.L, {
                                richText: textBlock
                            })
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/StaggeredHeadline.tsx





var StaggeredHeadline = function(param) {
    var headline = param.headline, reversed = param.reversed, hyphenate = param.hyphenate, htmlWrapper = param.htmlWrapper;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "lowercase",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* H2Display */.Zm, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(helpers/* HTMLWrapper */.oK, {
                wrapperElement: htmlWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridContainer */.T5, {
                    wrapperElement: "span",
                    children: !reversed ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* GridRowGroupTwo */.wS, {
                                wrapperElement: "span",
                                children: [
                                    headline[0],
                                    hyphenate && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "after:content-['–']"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridRowGroupOne */.Q9, {
                                wrapperElement: "span",
                                children: headline[1]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* GridRowGroupOne */.Q9, {
                                wrapperElement: "span",
                                children: [
                                    headline[0],
                                    hyphenate && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "after:content-['–']"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridRowGroupTwo */.wS, {
                                wrapperElement: "span",
                                children: headline[1]
                            })
                        ]
                    })
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/cms/ContentStaggeredHeadlineTextBlock.tsx







var ContentStaggeredHeadlineTextBlock = function(param) {
    var textBlock = param.textBlock, isReversed = param.isReversed, isHyphenated = param.isHyphenated, headlineHtmlElement = param.headlineHtmlElement, headingLine1 = param.headingLine1, headingLine2 = param.headingLine2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StaggeredHeadline, {
                htmlWrapper: headlineHtmlElement,
                headline: [
                    headingLine1,
                    headingLine2
                ],
                hyphenate: isHyphenated,
                reversed: isReversed
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* StaticSpacer */.rj, {
                size: "xs"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridContainer */.T5, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-full max-w-[600px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* BodyText */.Ac, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(_ContentfulRichTextContent/* ContentfulRichTextContent */.L, {
                            richText: textBlock
                        })
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/cms/ContentSuperDisplayBlock.tsx





var ContentSuperDisplayBlock = function(param) {
    var title = param.title, titleHtmlElement = param.titleHtmlElement;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridContainer */.T5, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridRowGroupOne */.Q9, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* SuperDisplay */.f7, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(helpers/* HTMLWrapper */.oK, {
                        wrapperElement: titleHtmlElement,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: title
                            }
                        })
                    })
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/cms/ContentTextBlockWithHeadline.tsx








var ContentTextBlockWithHeadline_getMaxWidth = function(contentMaxWidth) {
    switch(contentMaxWidth){
        case "860px":
            return "max-w-[860px]";
            break;
        case "960px":
            return "max-w-[960px]";
            break;
        case "1060px":
            return "max-w-[1060px]";
            break;
        case "1160px":
            return "max-w-[1160px]";
            break;
        case "1260px":
            return "max-w-[1260px]";
            break;
        case "1360px":
            return "max-w-[1360px]";
            break;
        case "1460px":
            return "max-w-[1460px]";
            break;
    }
};
var getColors = function(backgroundColor) {
    switch(backgroundColor){
        case "bg-almostBlack":
            return "bg-almostBlack text-white";
            break;
        case "bg-white":
            return "bg-white text-almostBlack";
            break;
        case "bg-yellow":
            return "bg-yellow text-almostBlack";
            break;
    }
};
var ContentTextBlockWithHeadline = function(param) {
    var backgroundColor = param.backgroundColor, _subheading = param.subheading, subheading = _subheading === void 0 ? "" : _subheading, subheadingHtmlElement = param.subheadingHtmlElement, _headline = param.headline, headline = _headline === void 0 ? "" : _headline, headlineHtmlElement = param.headlineHtmlElement, textBlock = param.textBlock, textBlockRightColumn = param.textBlockRightColumn, contentMaxWidth = param.contentMaxWidth;
    var target = (0,react.useRef)(null);
    var scrollYProgress = (0,use_scroll/* useScroll */.v)({
        target: target,
        offset: [
            "start end",
            "end center"
        ]
    }).scrollYProgress;
    var parallax = (0,use_transform/* useTransform */.H)(scrollYProgress, [
        0,
        1
    ], [
        -16,
        32
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "z-1 relative ".concat(getColors(backgroundColor)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* GridContainer */.T5, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-span-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                            size: "md"
                        }),
                        subheading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* BaseText */.k$, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(helpers/* HTMLWrapper */.oK, {
                                    wrapperElement: subheadingHtmlElement,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "lowercase  ".concat(backgroundColor === "bg-almostBlack" ? "text-yellow" : ""),
                                        dangerouslySetInnerHTML: {
                                            __html: subheading
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                    size: "xs"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                            className: "".concat(ContentTextBlockWithHeadline_getMaxWidth(contentMaxWidth)),
                            initial: "hide",
                            whileInView: "show",
                            variants: (0,helpers/* animationFadeInOut */.om)(),
                            children: headline && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* H2Display */.Zm, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(helpers/* HTMLWrapper */.oK, {
                                    wrapperElement: headlineHtmlElement,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        dangerouslySetInnerHTML: {
                                            __html: headline
                                        }
                                    })
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                initial: "hide",
                whileInView: "show",
                variants: (0,helpers/* animationFadeInOut */.om)(),
                style: {
                    y: (0,use_transform/* useTransform */.H)(parallax, function(v) {
                        return v * 2;
                    })
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* GridContainer */.T5, {
                        children: [
                            textBlock && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-full xl:col-span-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* BodyText */.Ac, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                            size: "sm"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(_ContentfulRichTextContent/* ContentfulRichTextContent */.L, {
                                            richText: textBlock
                                        })
                                    ]
                                })
                            }),
                            textBlockRightColumn && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-full xl:col-span-4 xl:col-start-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* BodyText */.Ac, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                            size: "sm"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(_ContentfulRichTextContent/* ContentfulRichTextContent */.L, {
                                            richText: textBlockRightColumn
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                            size: "lg"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    !textBlockRightColumn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                        size: "lg"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/cms/ContentTwoColumnTextBlockWithHeadline.tsx








var ContentTwoColumnTextBlockWithHeadline_getMaxWidth = function(contentMaxWidth) {
    switch(contentMaxWidth){
        case "860px":
            return "max-w-[860px]";
            break;
        case "960px":
            return "max-w-[960px]";
            break;
        case "1060px":
            return "max-w-[1060px]";
            break;
        case "1160px":
            return "max-w-[1160px]";
            break;
        case "1260px":
            return "max-w-[1260px]";
            break;
        case "1360px":
            return "max-w-[1360px]";
            break;
        case "1460px":
            return "max-w-[1460px]";
            break;
    }
};
var ContentTwoColumnTextBlockWithHeadline_getColors = function(backgroundColor) {
    switch(backgroundColor){
        case "bg-almostBlack":
            return "bg-almostBlack text-white";
            break;
        case "bg-white":
            return "bg-white text-almostBlack";
            break;
        case "bg-yellow":
            return "bg-yellow text-almostBlack";
            break;
    }
};
var ContentTwoColumnTextBlockWithHeadline = function(param) {
    var backgroundColor = param.backgroundColor, _subheading = param.subheading, subheading = _subheading === void 0 ? "" : _subheading, subheadingHtmlElement = param.subheadingHtmlElement, _headline = param.headline, headline = _headline === void 0 ? "" : _headline, headlineHtmlElement = param.headlineHtmlElement, textBlock = param.textBlock, _subheadingRightColumn = param.subheadingRightColumn, subheadingRightColumn = _subheadingRightColumn === void 0 ? "" : _subheadingRightColumn, subheadingRightColumnHtmlElement = param.subheadingRightColumnHtmlElement, _headlineRightColumn = param.headlineRightColumn, headlineRightColumn = _headlineRightColumn === void 0 ? "" : _headlineRightColumn, headlineRightColumnHtmlElement = param.headlineRightColumnHtmlElement, textBlockRightColumn = param.textBlockRightColumn, contentMaxWidth = param.contentMaxWidth;
    var target = (0,react.useRef)(null);
    var scrollYProgress = (0,use_scroll/* useScroll */.v)({
        target: target,
        offset: [
            "start end",
            "end center"
        ]
    }).scrollYProgress;
    var parallax = (0,use_transform/* useTransform */.H)(scrollYProgress, [
        0,
        1
    ], [
        -16,
        32
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "z-1 relative ".concat(ContentTwoColumnTextBlockWithHeadline_getColors(backgroundColor)),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* GridContainer */.T5, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-full md:col-span-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(ContentTwoColumnTextBlockWithHeadline_getMaxWidth(contentMaxWidth)),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                size: "md"
                            }),
                            subheading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* BaseText */.k$, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(helpers/* HTMLWrapper */.oK, {
                                        wrapperElement: subheadingHtmlElement,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "lowercase  ".concat(backgroundColor === "bg-almostBlack" ? "text-yellow" : ""),
                                            dangerouslySetInnerHTML: {
                                                __html: subheading
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                        size: "xs"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                initial: "hide",
                                whileInView: "show",
                                variants: (0,helpers/* animationFadeInOut */.om)(),
                                children: headline && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* H2Display */.Zm, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(helpers/* HTMLWrapper */.oK, {
                                        wrapperElement: headlineHtmlElement,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            dangerouslySetInnerHTML: {
                                                __html: headline
                                            }
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                initial: "hide",
                                whileInView: "show",
                                variants: (0,helpers/* animationFadeInOut */.om)(),
                                style: {
                                    y: (0,use_transform/* useTransform */.H)(parallax, function(v) {
                                        return v * 2;
                                    })
                                },
                                children: textBlock && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-span-full xl:col-span-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* BodyText */.Ac, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                                size: "sm"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(_ContentfulRichTextContent/* ContentfulRichTextContent */.L, {
                                                richText: textBlock
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-full md:col-span-6 md:col-start-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(ContentTwoColumnTextBlockWithHeadline_getMaxWidth(contentMaxWidth)),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                size: "md"
                            }),
                            subheadingRightColumn && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* BaseText */.k$, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(helpers/* HTMLWrapper */.oK, {
                                        wrapperElement: subheadingRightColumnHtmlElement,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "lowercase  ".concat(backgroundColor === "bg-almostBlack" ? "text-yellow" : ""),
                                            dangerouslySetInnerHTML: {
                                                __html: subheadingRightColumn
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                        size: "xs"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                className: "".concat(ContentTwoColumnTextBlockWithHeadline_getMaxWidth(contentMaxWidth)),
                                initial: "hide",
                                whileInView: "show",
                                variants: (0,helpers/* animationFadeInOut */.om)(),
                                children: headlineRightColumn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* H2Display */.Zm, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(helpers/* HTMLWrapper */.oK, {
                                        wrapperElement: headlineRightColumnHtmlElement,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            dangerouslySetInnerHTML: {
                                                __html: headlineRightColumn
                                            }
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                                initial: "hide",
                                whileInView: "show",
                                variants: (0,helpers/* animationFadeInOut */.om)(),
                                style: {
                                    y: (0,use_transform/* useTransform */.H)(parallax, function(v) {
                                        return v * 2;
                                    })
                                },
                                children: [
                                    textBlockRightColumn && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-span-full xl:col-span-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* BodyText */.Ac, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                                    size: "sm"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(_ContentfulRichTextContent/* ContentfulRichTextContent */.L, {
                                                    richText: textBlockRightColumn
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* ResponsiveSpacer */.Yj, {
                                        size: "lg"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/cms/__MapPageContent.tsx




















var MapPageContent = function(param) {
    var pageContent = param.pageContent;
    return pageContent.map(function(item, i) {
        switch(item.__typename){
            case "ComponentSpacers":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentSpacers, (0,_object_spread/* default */.Z)({}, item), "PageContent_ComponentSpacers_".concat(i));
                break;
            case "ComponentIcons":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentIcons, (0,_object_spread/* default */.Z)({}, item), "PageContent_ComponentIcons_".concat(i));
                break;
            case "ComponentForms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentForms, (0,_object_spread/* default */.Z)({
                    id: "PageContent_ComponentForms_".concat(i)
                }, item), "PageContent_ComponentForms_".concat(i));
                break;
            case "ComponentCallToAction":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentCallToAction, (0,_object_spread/* default */.Z)({}, item), "PageContent_ComponentCallToAction_".concat(i));
                break;
            case "ComponentCaseStudyGroup":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentCaseStudyGroup, (0,_object_spread/* default */.Z)({}, item), "PageContent_ComponentCaseStudyGroup_".concat(i));
                break;
            case "ComponentOpenRolesGroup":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentOpenRolesGroup, (0,_object_spread/* default */.Z)({}, item), "PageContent_ComponentOpenRolesGroup_".concat(i));
                break;
            case "ComponentBlogRoll":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentBlogRoll, (0,_object_spread/* default */.Z)({}, item), "PageContent_ComponentBlogRoll_".concat(i));
                break;
            case "ComponentImageWall":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentImageWall, (0,_object_spread/* default */.Z)({}, item), "PageContent_ComponentImageWall_".concat(i));
                break;
            case "ComponentIntroBlock":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentIntroBlock, (0,_object_spread/* default */.Z)({}, item), "PageContent_ComponentIntroBlock_".concat(i));
                break;
            case "ContentHeroTaglines":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentHeroTagline, (0,_object_spread/* default */.Z)({}, item), "PageContent_ContentHeroTaglines_".concat(i));
                break;
            case "ContentStaggeredHeadlineTextBlock":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentStaggeredHeadlineTextBlock, (0,_object_spread/* default */.Z)({}, item), "PageContent_ContentStaggeredHeadlineTextBlock_".concat(i));
                break;
            case "ContentTextBlockWithHeadline":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentTextBlockWithHeadline, (0,_object_spread/* default */.Z)({}, item), "PageContent_ContentTextBlockWithHeadline_".concat(i));
                break;
            case "ContentTwoColumnTextBlockWithHeadline":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentTwoColumnTextBlockWithHeadline, (0,_object_spread/* default */.Z)({}, item), "PageContent_ContentTwoColumnTextBlockWithHeadline_".concat(i));
                break;
            case "ContentCaseStudies":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCaseStudies, (0,_object_spread/* default */.Z)({}, item), "PageContent_ContentCaseStudies_".concat(i));
                break;
            case "ContentSuperDisplayBlock":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSuperDisplayBlock, (0,_object_spread/* default */.Z)({}, item), "PageContent_ContentSuperDisplayBlock_".concat(i));
                break;
            case "ContentRichTextArea":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentRichTextArea, (0,_object_spread/* default */.Z)({}, item), "PageContent_ContentRichTextArea_".concat(i));
                break;
            case "Careers":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryCard, {
                    title: item.displayTitle,
                    ctaText: item.ctaSummaryLink,
                    linkUrl: "/careers/".concat(item.slug),
                    summary: item.jobSummary
                });
                break;
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: item.__typename
                });
                break;
        }
    });
};


/***/ }),

/***/ 4132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S2": function() { return /* binding */ tradeOrgItems; },
/* harmony export */   "Wf": function() { return /* binding */ contactItems; },
/* harmony export */   "aZ": function() { return /* binding */ socialItems; },
/* harmony export */   "pO": function() { return /* binding */ menuItems; }
/* harmony export */ });
/* unused harmony exports workMenuItems, blogPosts */
var menuItems = [
    {
        text: "Development",
        href: "/development"
    },
    {
        text: "Product + UX Design",
        href: "/product-ux-design"
    },
    {
        text: "Expertise",
        href: "/expertise"
    },
    {
        text: "Culture",
        href: "/culture"
    },
    {
        text: "Work",
        href: "/work"
    },
    {
        text: "Careers",
        href: "/careers"
    }, 
];
var socialItems = [
    {
        text: "Instagram",
        href: "https://www.instagram.com/shiftlab.co/"
    },
    {
        text: "Facebook",
        href: "https://www.facebook.com/shiftlab.co/"
    },
    {
        text: "LinkedIn",
        href: "https://www.linkedin.com/company/shiftlabny/"
    },
    {
        text: "X",
        href: "https://x.com/shiftlabny/"
    }, 
];
var workMenuItems = [
    {
        text: "Ecommerce",
        href: "/work"
    },
    {
        text: "Content Platforms",
        href: "/work"
    },
    {
        text: "Healthcare",
        href: "/work"
    },
    {
        text: "Fintech",
        href: "/work"
    },
    {
        text: "Established Startups",
        href: "/work"
    },
    {
        text: "Lifestyle + Travel",
        href: "/work"
    }, 
];
var contactItems = [
    {
        label: "Careers",
        text: "careers@shiftlab.co"
    },
    {
        label: "General Inquiries",
        text: "info@shiftlab.co"
    },
    {
        label: "New Business",
        text: "newbiz@shiftlab.co<br />+ 1 646 360 0498"
    }, 
];
var tradeOrgItems = [
    {
        text: "Shift Lab is a proud member of SoDA, The Society of Digital Agencies",
        href: "https://sodaspeaks.com",
        imagePath: "/images/soda.png",
        imageSize: {
            height: 120,
            width: 94
        }
    },
    {
        text: "Shift Lab is a proud member of The Bureau of Digital",
        href: "https://bureauofdigital.com/",
        imagePath: "/images/bureau-of-digital.png",
        imageSize: {
            height: 120,
            width: 220
        }
    }, 
];
var blogPosts = [
    {
        title: "Using ChatGPT as a Development Tool",
        slug: "/thinking/shift-lab-using-chatgpt-as-a-development-tool"
    },
    {
        title: "How High-Value Technology Projects Can Increase Lifetime Account Value",
        slug: "/thinking/shift-lab-how-high-value-technology-projects-can-increase-lifetime-account-value"
    },
    {
        title: "Top 8 Tech Development Pitfalls for Design Agencies ",
        slug: "/thinking/shift-lab-top-8-tech-development-pitfalls-for-design-agencies"
    }, 
];


/***/ }),

/***/ 1125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// eslint-disable-next-line @typescript-eslint/no-var-requires

var tokens = __webpack_require__(536);
module.exports = {
    content: [
        "./pages/**/*.{ts,tsx}",
        "./components/**/*.{ts,tsx}",
        "./stories/**/*.{ts,tsx}", 
    ],
    theme: {
        colors: {
            almostBlack: tokens.global.colors.almostBlack.value,
            white: tokens.global.colors.white.value,
            yellow: tokens.global.colors.yellow.value,
            black: tokens.global.colors.black.value,
            transparent: "transparent",
            debugSpacing: tokens.global.colors.debugSpacing.value,
            debugGrid: tokens.global.colors.debugGrid.value
        },
        fontFamily: {
            sans: [
                tokens.global.fontFamily.sans.value
            ]
        },
        fontWeight: {
            normal: tokens.global.fontWeight.normal.value,
            medium: tokens.global.fontWeight.medium.value,
            bold: tokens.global.fontWeight.bold.value
        },
        fontSize: {
            super: [
                "13.75rem",
                {
                    lineHeight: 0.95,
                    letterSpacing: -0.5
                }, 
            ],
            "3xl": [
                "5.75rem",
                {
                    lineHeight: 1,
                    letterSpacing: 0.5
                }, 
            ],
            "2xl": [
                "3.5rem",
                {
                    lineHeight: 1,
                    letterSpacing: -0.35
                }, 
            ],
            xl: [
                "2.5rem",
                {
                    lineHeight: 1,
                    letterSpacing: -0.25
                }, 
            ],
            lg: [
                "1.4rem",
                {
                    lineHeight: 1.15,
                    letterSpacing: 0.14
                }, 
            ],
            md: [
                "1.125rem",
                {
                    lineHeight: 1.2,
                    letterSpacing: 0.125
                }, 
            ],
            sm: [
                "1rem",
                {
                    lineHeight: 1.2,
                    letterSpacing: 0.1
                }, 
            ],
            xs: [
                ".85rem",
                {
                    lineHeight: 1.2,
                    letterSpacing: 0.1
                }, 
            ]
        },
        extend: {
            spacing: {
                18: "4.5rem",
                30: "7.5rem",
                38: "9.55rem",
                58: "14.55rem",
                76: "19rem",
                98: "29rem"
            },
            gridTemplateColumns: {
                13: "repeat(13, minmax(0, 1fr))"
            }
        }
    },
    variant: {
        extend: {}
    },
    plugins: [
        __webpack_require__(4863),
        __webpack_require__(130)({
            strategy: "class"
        }), 
    ]
};


/***/ }),

/***/ 7479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$c": function() { return /* binding */ animationFlyInOut; },
/* harmony export */   "VK": function() { return /* binding */ currentYear; },
/* harmony export */   "Xi": function() { return /* binding */ imgixLoader; },
/* harmony export */   "_u": function() { return /* binding */ contentfulImageLoader; },
/* harmony export */   "aK": function() { return /* binding */ animationRotate; },
/* harmony export */   "oK": function() { return /* binding */ HTMLWrapper; },
/* harmony export */   "om": function() { return /* binding */ animationFadeInOut; },
/* harmony export */   "pe": function() { return /* binding */ getThemeColor; }
/* harmony export */ });
/* unused harmony export getFullPath */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _tailwind_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1125);
/* harmony import */ var _tailwind_config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_tailwind_config__WEBPACK_IMPORTED_MODULE_2__);



var imgixLoader = function(param) {
    var src = param.src, width = param.width, quality = param.quality, format = param.format;
    return "https://shiftlab.imgix.net/".concat(src, "?w=").concat(width, "&q=").concat(quality || 75, "&fm=").concat(format || "webp");
};
var contentfulImageLoader = function(param) {
    var src = param.src, width = param.width, quality = param.quality, fit = param.fit, format = param.format;
    return "".concat(src, "?w=").concat(width, "&fit=").concat(fit, "&q=").concat(quality || 90, "&fm=").concat(format || "webp");
};
var currentYear = new Date().getFullYear();
var getThemeColor = function(color) {
    return _tailwind_config__WEBPACK_IMPORTED_MODULE_2__.theme.colors[color];
};
var getFullPath = function(pageSlug) {
    var slug = "";
    pageSlug.map(function(item) {
        return slug = slug + item + "/";
    });
    return slug.slice(0, -1);
};
var HTMLWrapper = function(param) {
    var wrapperElement = param.wrapperElement, children = param.children, classes = param.classes;
    var element = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classes,
        children: children
    });
    switch(wrapperElement){
        case "h1":
            element = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: classes,
                children: children
            });
            break;
        case "h2":
            element = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: classes,
                children: children
            });
            break;
        case "h3":
            element = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: classes,
                children: children
            });
            break;
        case "h4":
            element = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                className: classes,
                children: children
            });
            break;
        case "h5":
            element = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                className: classes,
                children: children
            });
            break;
        case "h6":
            element = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                className: classes,
                children: children
            });
            break;
        case "ol":
            element = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                className: classes,
                children: children
            });
            break;
        case "ul":
            element = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: classes,
                children: children
            });
            break;
        case "span":
            element = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: classes,
                children: children
            });
            break;
        case "section":
            element = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: classes,
                children: children
            });
            break;
        case "p":
            element = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: classes,
                children: children
            });
            break;
    }
    return element;
};
var animationFadeInOut = function() {
    return {
        hide: {
            opacity: 0
        },
        show: {
            opacity: 1,
            transition: {
                delay: 0.25,
                duration: 1.5,
                ease: "linear",
                type: "spring"
            }
        }
    };
};
var animationFlyInOut = function(param) {
    var direction = param.direction;
    return {
        hide: {
            opacity: 0,
            x: direction === "flyInFromRight" ? 300 : -300
        },
        show: {
            opacity: 1,
            x: 0,
            transition: {
                delay: 0.75,
                duration: 0.25,
                ease: "linear",
                type: "spring"
            }
        }
    };
};
var animationRotate = function() {
    return {
        hide: {
            rotate: -45
        },
        show: {
            rotate: 0,
            transition: {
                delay: 0.1,
                duration: 0.25,
                ease: "linear",
                type: "spring"
            }
        }
    };
};


/***/ }),

/***/ 536:
/***/ (function(module) {

module.exports = JSON.parse('{"global":{"colors":{"almostBlack":{"value":"#101010","type":"color"},"yellow":{"value":"#FFC72C","type":"color"},"black":{"value":"#000000","type":"color"},"white":{"value":"#FFFFFF","type":"color"},"debugSpacing":{"value":"rgba(255,0,214,.2)","type":"color"},"debugGrid":{"value":"rgba(255,255,255,.2)","type":"color"}},"fontFamily":{"sans":{"value":"\'Aeonik\', \'Helvetica Neue\', \'Arial\', \'sans-serif\'","type":"fontFamilies"}},"fontWeight":{"bold":{"value":"700","type":"fontWeights"},"medium":{"value":"500","type":"fontWeights"},"normal":{"value":"500","type":"fontWeights"}}},"$themes":[]}');

/***/ })

}]);